import Vue from 'vue'
import Vuex from 'vuex'
import { Auth } from 'aws-amplify'
import router from './router/approuter'


Vue.use(Vuex)

//-----------------------------------------------------------------------
// Helper functions (defined outside the 'actions' object)
//-----------------------------------------------------------------------
function createCommandPromise(context, command) {
    return new Promise((resolve, reject) => {
        const commandId = command.cuid;
        let timeoutId = null;

        // --- 1. Setup Timeout ---
        timeoutId = setTimeout(() => {
            context.commit('removePendingCommand', commandId); //elimina la Promise per pulizia
            clearTimeout(timeoutId); //azzeriamo il timer (forse ridondante)
            reject(new Error(`Command ${command.wsPayload.action} timeout`)); //reject l'errore
        }, command.timeout);

        // --- 2. Store Handlers ---
        context.commit('setPendingCommands', {
            id: commandId,
            val: { resolve, reject, timeoutId }
        });

        // --- 3. Send Command via WebSocket ---
        console.log("Sending command: ", command.wsPayload);
        Vue.prototype.$socket.sendObj(command.wsPayload);
    });
}

export const store = new Vuex.Store({
    state: {
        showDevFeatures: false, //Modificare questo per nascondere le nuove funzionalità in sviluppo prima di pushare

        adminData: {
            allUsers: null
        },
        clientRegistrationData: null,
        invite: null,
        inviteType: null,
        appConfig: {},
        reconnecting: false,
        connecting: false,
        socketId: null,
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false
        },
        reconnectCount: 0,
        loading: true,
        error: null,
        user: null,
        token: null,
        userLastPlants: [],
        userAllPlants: [],
        currentPlant: null,
        currentLogbooks: null,
        currentZone: null,
        plantUnits: null,
        plantCollections: null,
        plantScenes: null,
        plantZones: null,
        monitoringZones: null,
        bleLogbooks:null,
        timezoneLocation: null,
        timezoneUtcOffset: null,
        commandsPending: 0,
        commandResponses: [],
        pendingUsers: [],
        allUsers: [],
        allTokens: [],

        commandResponse: {
            pending: false,
            cu: null,
            command: null,
            response: null,
            error: null,
            timeout: 5,
            retry: 0,
            timeoutId: null
        },
        userSummaryPlants: null,
        savedSummaryPlants:null,
        loadingLogbookDetails: false,
        pendingCommands: [], //array di promise pendenti per comandi inviati con websocket
        MainsLogbooks: null,
    },
    mutations: {
        SOCKET_ONOPEN(state, event) {
            console.log("socket onopen, reconnecting=" + state.reconnecting, event)
            state.reconnectCount = 0;
            Vue.prototype.$socket = event.currentTarget
            state.socket.isConnected = true
            state.connecting = false
            if (state.reconnecting) {
                state.reconnecting = false;

                if (state.currentPlant != null) {
                    //Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: details.plant_id } });
                    Vue.prototype.$axios.post('', {
                        action: 'getPlantDetails',
                        plantId: state.currentPlant.plant_id, //this.details.plant_id,
                        socketId: state.socketId
                    }).then(function(response) {
                        console.log("arrivato callback post plant details after socket on open", response);
                        state.context.loading = false;
                        state.context.commit('setPlantDetails', response.data)
                            //context.commit('updateUserAllPlants',response.data.data);
                    })
                    .catch(function(error) {
                        console.log("errore post", error);
                    });
                    if (state.userLastPlants.length > 0) {
                        return;
                    }
                }
            }
            let usersub = (state.user.attributes['custom:iduser'] != null) ? state.user.attributes['custom:iduser'] : state.user.attributes.sub;

            Vue.prototype.$socket.sendObj({ action: 'getUserInfos', data: { id: usersub, email: state.user.attributes.email } });
        },
        SOCKET_ONCLOSE(state, event) {
            console.log("socket onclose", event, state.user)
            state.socket.isConnected = false
            state.connecting = false

            //if (1>0) return;

            if (state.user == null) return //ha fatto logout a mano;
            console.log("cognito session:", state.user.signInUserSession);

            console.log("riloggo utente e riconnetto socket");

            Auth.currentSession().then(data => {
                console.log("current session completed, data =", data);

                state.reconnectCount++;
                if (state.reconnectCount <= 3) {
                    console.log("reconnect socket " + state.reconnectCount);
                    state.connecting = true;
                    state.reconnecting = true;
                    state.userLastPlants = [];
                    state.user.signInUserSession = data;
                    let token = state.user.signInUserSession.idToken.jwtToken;
                    let wsUrl = process.env.VUE_APP_WEBSOCKET_URL + "?token=" + token;
                    Vue.prototype.$connect(wsUrl);
                } else {
                    state.user = null
                    console.log("logout!");
                    Auth.signOut().then(data => {
                        console.log("rimando alla login")
                        router.push({ name: 'Login' });
                    });

                }

            }).catch(err => {
                console.log("current session failed", err);
                state.user = null
                console.log("logout!");
                Auth.signOut().then(data => {
                    console.log("rimando alla login")
                    router.push({ name: 'Login' });
                });
            });

            /*state.reconnectCount++;
            if (state.reconnectCount <= 3) {
                console.log("reconnect socket " + state.reconnectCount);
                state.connecting = true;
                state.userLastPlants = [];
                let token = state.user.signInUserSession.idToken.jwtToken;
                let wsUrl = process.env.VUE_APP_WEBSOCKET_URL + "?token=" + token;
                Vue.prototype.$connect(wsUrl);
            } else {
                state.user = null
                console.log("logout!");
                Auth.signOut().then(data => {
                    console.log("rimando alla login")
                    router.push({name: 'Login'});
                });

            }*/

            /*state.user = null
            console.log("logout!");
            Auth.signOut().then(data => {
                console.log("rimando alla login")
                router.push({name: 'Login'});
            });*/

        },
        SOCKET_ONERROR(state, event) {
            console.error(state, event)
            state.connecting = false
        },
        // default handler called for all methods
        SOCKET_ONMESSAGE(state, message) {
            console.log("message received:", message)
            state.socket.message = message;
        },
        // mutations for reconnect methods
        SOCKET_RECONNECT(state, count) {
            console.log("reconnect!", state, count);
            state.reconnecting = true;
        },
        SOCKET_RECONNECT_ERROR(state) {
            console.log("reconnect error!!!", state);
            state.socket.reconnectError = true;

            state.socket.isConnected = false
            state.connecting = false

            state.user = null
            console.log("logout!");
            Auth.signOut().then(data => {
                console.log("rimando alla login")
                router.push({ name: 'Login' });
            });

        },
        setLoggedUser(state, u) {
            console.log("set logged user to:", u);
            state.user = u;
            if (u == null) {
                if (state.socket.isConnected) {
                    console.log("disconnect socket");
                    Vue.prototype.$disconnect();
                }
            } else {
                //if (!state.socket.isConnected && !state.connecting) {
                state.connecting = true;
                state.userLastPlants = [];
                let token = state.user.signInUserSession.idToken.jwtToken;
                let wsUrl = process.env.VUE_APP_WEBSOCKET_URL + "?token=" + token;
                Vue.prototype.$connect(wsUrl);
                //}
            }
        },
        firstLogin(state, u) {
            state.user = null;
            router.push("/login");
        },
        updateUserInfos(state, uinfo) {
            Vue.set(state.user, "usertype", uinfo.usertype);
            Vue.set(state.user, "name", uinfo.name);
            Vue.set(state.user, "surname", uinfo.surname);
            Vue.set(state.user, "phone", uinfo.phone);
            Vue.set(state.user, "piva", uinfo.piva);
            Vue.set(state.user, "email", uinfo.username);
            Vue.set(state.user, "businessname", uinfo.businessname);
            Vue.set(state.user, "validation", uinfo.validation);
            state.socketId = uinfo.socketId;
            console.log("user marketing", uinfo.marketingConsent);
            console.log("user socketId=" + state.socketId);
            if (uinfo.address) {
                Vue.set(state.user, "street", uinfo.address.street);
                Vue.set(state.user, "housenumber", uinfo.address.housenumber);
                Vue.set(state.user, "prov", uinfo.address.prov);
                Vue.set(state.user, "cap", uinfo.address.cap);
                Vue.set(state.user, "city", uinfo.address.city);
                Vue.set(state.user, "country", uinfo.address.country);
            }
            if (uinfo.marketingConsent) {
                Vue.set(state.user, "marketing", uinfo.marketingConsent.marketing);
                Vue.set(state.user, "profiling", uinfo.marketingConsent.profiling);
                Vue.set(state.user, "thirdparts", uinfo.marketingConsent.thirdparts);
            }
            if (uinfo.nominaAccepted) {
                Vue.set(state.user, "nominaAccepted", uinfo.nominaAccepted);
            }
            if (uinfo.disclaimerPhotoAccepted) {
                Vue.set(state.user, "disclaimerPhotoAccepted", uinfo.disclaimerPhotoAccepted);
            }
            state.appConfig = uinfo.appConfig;
            //state.userLastPlants = uinfo.recentPlants || [];
            console.log("appConfig Max CU: ",  state.appConfig);
            console.log("recentPlants utente:", uinfo.recentPlants);
            Vue.set(state, "userLastPlants", uinfo.recentPlants || []);
            state.loading = false;
        },
        updateSingleProductInfo(state, productInfo) {
            state.singleProductInfo = productInfo;
            state.loading = false;
        },
        updateFamilyInfo(state, familyInfo) {
            state.familyInfo = familyInfo;
            state.loading = false;
        },
        updateAllCuProductInfo(state, productInfo) {
            state.allCuProductInfo = productInfo;
            state.loading = false;
        },
        updateUserAllPlants(state, allplants) {
            state.userAllPlants = allplants;
            state.loading = false;
        },
        updateUserSummaryPlants(state, summaryplants) {
            state.userSummaryPlants = summaryplants;
            state.loading = false;
        },
        updateAldiPlants(state, aldiplants) {
            state.aldiPlants = aldiplants;
            state.loading = false;
        },
        updateUserAllUsers(state, allusers) {
            state.allUsers = allusers;
            state.loading = false;
        },
        updateUserAllTokens(state, alltokens) {
            state.allTokens = alltokens;
            state.loading = false;
        },
        setPlantDetails(state, details) {
            state.currentPlant = details;
            state.loading = false;
        },
        setBleLogbooks(state, bleLogbooks) {
            state.bleLogbooks = bleLogbooks;
            console.log("bleLogbooks", bleLogbooks);
            state.loading = false;
        },
        setPlantCollections(state, collections) {
            state.plantCollections = collections;

            var resp = {
                pending: false,
                command: 'plantCollections',
                response: collections
            }
            Vue.set(state, "commandResponse", resp);

            state.loading = false;
        },
        setPlantZones(state, zones) {
            state.plantZones = zones;
            console.log("Zone bluetooth", zones);
            state.loading = false;
        },
        setMonitoringZones(state, zones) {
            state.monitoringZones = zones;
            console.log("Zone di monitoraggio", zones);
            state.loading = false;
        },
        setPlantScenes(state, scenes) {
            state.plantScenes = scenes;
            state.loading = false;
        },
        setLogbookDetails(state, details) {
            state.currentLogbooks = details;
            state.loading = false;
        },
        setUnitsDetails(state, details) {
            var totCablecom = 0;
            var totLogica = 0;
            var totLogicaFM = 0;
            var totSicuro = 0;
            var totGatewayBle =0;
            var primoTipo = "";

            console.log("appConfig: ",state.appConfig);
            console.log("setUnitsDetails, details:", details);
            for (var i = 0; i < details.length; i++) {
                var centType = details[i]["cu_type"];
                details[i]['enabled'] = true;
                if (primoTipo == "") {
                    primoTipo = centType;
                } else {
                    if (centType != primoTipo && this.getters.isProExpired) {
                        details[i]['enabled'] = false;
                    }
                }

                if (this.getters.isProExpired) {
                    if (centType == 'cablecom') {
                        totCablecom++;
                        if (totCablecom > state.appConfig.maxCablecomUnits) {
                            details[i]['enabled'] = false;
                        }
                    } else if (centType == 'logica') {
                        totLogica++;
                        if (totLogica > state.appConfig.maxLogicaUnits) {
                            details[i]['enabled'] = false;
                        }
                    } else if (centType == 'logicafm') {
                        totLogicaFM++;
                        console.log("appConfig: ",state.appConfig);
                        if (totLogicaFM > state.appConfig.maxLogicaFmUnits) {
                            details[i]['enabled'] = false;
                        }
                    } else if (centType == 'sicuro') {
                        totSicuro++;
                        if (totSicuro > state.appConfig.maxSicuroUnits) {
                            details[i]['enabled'] = false;
                        }
                    } else {
                        totGatewayBle++;
                        if (totGatewayBle > state.appConfig.maxGatewayUnits) {
                            details[i]['enabled'] = false;
                        }
                    }

                }

                details[i]["working"] = false;
                state.timezoneLocation = details[i].cu_location;
                state.timezoneUtcOffset = details[i].cu_utc_offset;
            }
            state.plantUnits = details;
            state.loading = false;
        },
        selectPlant(state,details) {
            console.log("cambio plant:", state, details)
            console.log("last plants:" , state.userLastPlants)
            let recPlants = state.userLastPlants
            let index = details.plant_index
            let plant = recPlants[index]
            recPlants.splice(index, 1)
            recPlants.unshift(plant)
            state.userLastPlants = recPlants
            console.log('ora last plants =', state.userLastPlants)
            //Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: details.plant_id } });
            Vue.prototype.$axios.post('', {
                action: 'getPlantDetails',
                plantId: details.plant_id,
                socketId:state.socketId
            }).then(function(response) {
                console.log("arrivato callback post plant details after select Plant", response);
                this.context.loading = false;
                this.context.commit('setPlantDetails', response.data)
                    //context.commit('updateUserAllPlants',response.data.data);
            })
            .catch(function(error) {
                console.log("errore post", error);
            });
            //si chiama il router solo se è effettivamente cambiato l'impianto per evitare di ricaricare tutta la pagina
            if (router.currentRoute.params.pid !== details.plant_id) {
              router.push({ name: 'HomeImpianto', params: { pid: details.plant_id } })
            }
        },

        checkCommandTimeout(state, cu_id) {
            var resp = state.commandResponses["" + cu_id];
            console.log("checkCommandTimeout su cent " + cu_id + ", resp=", resp);


            var retryLeft = resp.retry - 1;
            console.log("retry left:" + retryLeft);
            if (retryLeft > 0) {
                state.commandResponse.retry = state.commandResponse.retry - 1;
                resp.retry = resp.retry - 1;
                return true;
            } else {
                console.log("Ritorno errore timeout, commandsPending = " + state.commandsPending);
                resp.error = "Invio comando fallito: mancata risposta dalla centrale";
                resp.pending = false;
                resp.retry = 0;
                state.commandResponse.retry = 0;

                if (state.commandsPending == 1) {
                    console.log("metto a 0");
                    state.commandsPending = 0;
                    state.loading = false;
                } else {
                    state.commandsPending = Math.max(0, state.commandsPending - 1);
                    if (state.commandsPending == 0) state.loading = false;
                }
                //state.error = "Invio comando fallito: mancata risposta dalla centrale";
            }
        },

        setCommandResponse(state, data) {
            state.commandResponse = data;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setError(state, val) {
            state.error = val;
        },
        setInfo(state, val) {
            state.info = val;
        },
        setSuccess(state, val) {
            state.success = val;
        },
        setWarning(state, val) {
            state.warning = val;
        },
        setCommandPending(state, val) {
            state.commandsPending = val;
        },
        setCommandsPending(state, val) {
            state.commandsPending = val;
        },
        setCommandResponses(state, { id, val }) {
            console.log("setCommandResponses id=" + id + ", val=", val);
            state.commandResponses[id] = val;
            console.log("elenco comandi inviati ora:", state.commandResponses);
        },
        setPendingCommands(state, { id, val }) {
            console.log("setPendingCommands id=" + id + ", val=", val);
            state.pendingCommands[id] = val;
        },
        removePendingCommand(state, commandId) {
            // Use the delete operator to remove the property from the reactive object
            delete state.pendingCommands[commandId];
        },
        setMainsLogbooks(state, logs) {
            this.state.MainsLogbooks = logs;
            console.log("MainsLogbooks", this.state.MainsLogbooks);
        },
        REMOVE_MAP_ITEM(state, payload) {
          const { section, ambId } = payload;
          // 1. Remove the index from the specified section (ambienti o planimetrie)
          const targetArray = state.currentPlant[section];
          const actualIndex = targetArray.findIndex(item => item.id === ambId);
          if (actualIndex !== -1) {
            targetArray.splice(actualIndex, 1);
          }
          // 2. Remove from the folder list ([0] is the section itself, the rest are folders that may contain that ambiente)
          const folderKey = section + '_folders';
          const folderList = state.currentPlant[folderKey];
          if (Array.isArray(folderList)) {
            folderList.some(ambiente => {
              const folderIndex = ambiente.ambientesIds.indexOf(ambId);
              if (folderIndex !== -1) {
                ambiente.ambientesIds.splice(folderIndex, 1);
                return true;
              }
              return false;
            });
          }
        },
        SYNC_MAPS_FOLDERS(state, payload) {
          const { section, maps, folders } = payload;
          // Aggiorna le mappe e le cartelle nella sezione specificata
          state.currentPlant[section] = maps;
          const folderKey = section + '_folders';
          state.currentPlant[folderKey] = folders;
        }
    },
    getters: {
        user: state => state.user,
        userName: state => {
            if (state.user == null || state.user.attributes == null) return "User"
            return state.user.name + " " + state.user.surname
        },
        userNick: state => {
            if (state.user == null || state.user.attributes == null) return "User"
            return state.user.name
        },
        userId: state => {
            if (state.user == null) return null;
            return state.user.username
        },
        userType: state => {
            console.log("stato User", state.user);
            if (state.user == null) return 'basic'
            console.log("stato User Type", state.user.usertype);
            return state.user.usertype || 'basic'
        },
        isBasic: (state, getters) => {
            return getters.userType == 'basic'
        },
        userRole: (state, getters) => {
            if (state.currentPlant == null) return null;
            if (state.user == null) return null;
            if (getters.userType == 'admin') return 'installer';
            let userInfo = state.currentPlant.plant_users.filter(function(u) {
                return u.userid == state.user.username;
            });
            if (userInfo == null || userInfo.length == 0) return null;
            return userInfo[0].role;
        },
        isCovidLamp: (state) => (lamp) => {
            console.log("check iscovidLamp " + lamp.product_code);
            return lamp.product_code == '1300005A7';
        },
        isProExpired: (state) => {
            const plant = state.currentPlant;
            if (plant == null) return false;
            if (plant.plant_type == 'pro') {
                if (plant.pro_expiry == null || plant.pro_expiry == "" || plant.pro_expiry == 'null') return true;
                const adesso = new Date();
                const expDate = new Date(Date.parse(plant.pro_expiry));
                console.log("pro expiry:" + plant.pro_expiry + ", expDate:" + expDate + ", adesso:" + adesso);
                if (expDate.getTime() < adesso.getTime()) return true;
            }
            return false;
        },
        isBluetooth: (state) => {
            console.log("check is Bluetooth!");
            const plant = state.currentPlant;

            if (plant == null) return false;
            if (!plant.ble_lamps) return false;
            if (plant.ble_lamps.length > 0)
                {
                    console.log(plant + "is Bluetooth!");
                    return true;
                }
            else
                return false;
        },
        isCentralized: (state) => {
            console.log("check is Centralized!");
            const plant = state.currentPlant;

            if (plant == null) return false;
            if (!plant.controlunits) return false;
            if (plant.controlunits.length > 0 || (plant.controlunits.length==0 && (plant.ble_lamps==null || plant.ble_lamps.length==0)))
                {
                    console.log(plant + "is Centralized!");
                    return true;
                }
            else
                return false;
        },
        containsSicuroCentral: (state) => {
            const plant = state.currentPlant;
            console.log("check containsSicuroCentral!: ", plant);
            return plant.controlunits.some((cu) => cu.cutype === 'sicuro');
        },
    },
    actions: {
        async aggiornaMapsAndFolders({ commit, dispatch, state }, payload) {
          const { plantId, section, maps, folders } = payload;
          // 1. Update local UI immediately (Optimistic update)
          commit('SYNC_MAPS_FOLDERS',{ section, maps, folders });
          // 2. Sync with the server
          try {
            await dispatch("aggiornaMappePost", {
              plantId: plantId,
              mapType: section,
              maps: state.currentPlant[section],
              folders: state.currentPlant[section + '_folders']
            });
          } catch (error) {
            console.error("failed to sync maps and folders:", error);
          }
        },

        //Rimuove una mappa (ambiente) dall'interfaccia e poi sincronizza con il server, in modo da avere un feedback immediato per l'utente (ottimistic update)
        async deleteMapAndSync({ commit, dispatch, state }, payload) {
          const { section, ambId, plantId } = payload;
          // 1. Update local UI immediately (Optimistic update)
          commit('REMOVE_MAP_ITEM', { section, ambId });
          // 2. Sync with the server
          try {
            await dispatch("aggiornaMappePost", {
              plantId: plantId,
              mapType: section,
              maps: state.currentPlant[section],
              folders: state.currentPlant[section + '_folders']
            });
          } catch (error) {
            console.error("failed to sync deletion:", error);
          }
        },
        reply(context, msg) {
            console.log("ricevuto comando reply");
            console.log("data", msg.data);
        },
        userInfos(context, msg) {
            console.log("ricevuto comando userInfos", msg.data);
            context.commit('updateUserInfos', msg.data);
        },
        allPlants(context, msg) {
            console.log("ricevuto comando allPlants");
            console.log("data", msg.data);
            context.commit('updateUserAllPlants', msg.data);
        },
        userLastPlants(context, msg) {
            console.log("ricevuto userLastPlants");
            console.log("data", msg.data);
            context.commit('setLastPlants', msg.data);
        },
        uploadImage(context, data) {
            console.log("invio immagine a lambda:", data);
            Vue.prototype.$socket.sendObj({ action: 'uploadImage', data: data });
        },
        updateUserValidation(context, data) {
            console.log("invio richiesta updateUserValidation ", data);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateUserValidation', data: data });
        },
        userValidationUpdated(context, msg) {
            console.log("ricevuta user validation updated:", msg);
            context.state.loading = false;
        },
        loadPendingUsers(context, userId) {
            console.log("invio richiesta loadPendingUsers di " + userId)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'getPendingUsers', data: { userId: userId } });
        },
        pendingUsers(context, msg) {
            console.log("ricevuti pendingUsers:", msg);
            context.state.pendingUsers = msg.data.users;
            context.state.loading = false;
        },

        loadAllUsers(context, data) {
            console.log("invio richiesta all users post di " + data);
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getAllUsers',
                    userId: context.state.user.username,
                    socketId: context.state.socketId
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateUserAllUsers', response.data);
                    //context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        loadAllTokens(context, data) {
            console.log("invio richiesta all tokens post di " + data);
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getAllTokens',
                    userId: context.state.user.username,
                    socketId: context.state.socketId
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateUserAllTokens', response.data);
                    //context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        checkSocketConnection(context, data) {
            return new Promise((resolve,reject) => {

                var maxloops = (data.maxWait || 10000) / 500;
                if (context.state.socket.isConnected && !context.state.loading) {
                    resolve(true);
                    return;
                }
                var currentLoop = 0;
                var checkInterval = window.setInterval(()=>{
                    if (context.state.socket.isConnected && !context.state.loading) {
                        window.clearInterval(checkInterval);
                        resolve(true);
                        return;
                    }
                    currentLoop++;
                    if (currentLoop > maxloops) {
                        window.clearInterval(checkInterval);
                        resolve(false);
                    }
                },500);
            });
        },

        createTokens(context, data) {

            console.log("creo tokens", data);

            return new Promise((resolve, reject) => {
                context.state.loading = true;
                //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
                Vue.prototype.$axios.post('', {
                        action: 'createTokens',
                        userId: context.state.user.username,
                        socketId: context.state.socketId,
                        tokens: data
                    })
                    .then(function(response) {
                        console.log("post eseguita", response);
                        resolve(response);
                        //context.state.loading = false;
                    })
                    .catch(function(error) {
                        console.log("errore post", error);
                        resolve(error);
                    });
            });

        },
        loadAllPlantsPost(context, data) {
            console.log("invio richiesta all plants post di " + data.userId);
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getAllPlants',
                    userId: context.state.user.username,
                    socketId: context.state.socketId
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateUserAllPlants', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });


            //console.log("committo esito loadAllPlants", Vue.prototype);
            //context.commit('updateUserAllPlants',data);
        },
        loadSummaryPlantsPost(context, data) {
            console.log("invio richiesta summary plants post di " + data.userId);
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'getSummaryPlants',
                    userId: context.state.user.username,
                    socketId: context.state.socketId
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateUserSummaryPlants', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
        loadAldiPlantsPost(context, data) {
            console.log("invio richiesta Aldi plants post di " + data.userId);
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'getAldiPlants',
                    userId: context.state.user.username,
                    socketId: context.state.socketId
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateAldiPlants', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
        loadBleLogbooks(context, plantId) {
            console.log("invio richiesta ble logbooks " + plantId);
            context.state.loading = true;
            context.state.bleLogbooks = null;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getBleLogbooks',
                    plantId: plantId,
                    socketId: context.state.socketId,
                })
                .then(function(response) {
                    console.log("arrivato callback post bleLogbooks ", response);
                    context.commit('setBleLogbooks', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });


            //console.log("committo esito loadAllPlants", Vue.prototype);
            //context.commit('updateUserAllPlants',data);
        },
        updateZone(context, data) {

            context.state.loading = true;
            context.state.error = null;
            var zoneInfo={};
            zoneInfo.collections = data.collections;
            zoneInfo.groups = data.groups;
            zoneInfo.scenes = data.scenes;
            zoneInfo.plantId = data.plantId;
            zoneInfo.zoneId = data.zoneId;
            zoneInfo.zoneName = data.zoneName;
            console.log("invio update zone  " , zoneInfo);
            Vue.prototype.$socket.sendObj({ action: 'updateZone', data: { zoneInfo: zoneInfo } });
        },

        //------------------------------------------------------------ //
        //------------------------- MONITORING ZONE ------------------- //
        //------------------------------------------------------------ //
        createMonitoringZone(context, data) {
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'createMonitoringZone',
                    plantId: data.plantId,
                    zoneId: data.zoneId,
                    lamps: data.lamps,
                    name: data.zoneName,
                    socketId: context.state.socketId,
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    var resp = {
                        pending: false,
                        command: 'createMonitoringZone',
                        error: response
                    }
                    Vue.set(context.state, "commandResponse", resp);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
        updateMonitoringZone(context, data) {
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'updateMonitoringZone',
                    plantId: data.plantId,
                    zoneId: data.zoneId,
                    lamps: data.lamps,
                    name: data.zoneName,
                    socketId: context.state.socketId,
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    var resp = {
                        pending: false,
                        command: 'updateMonitoringZone',
                        error: response
                    }
                    // Vue.set(context.state, "commandResponse", resp);
                    context.commit('setCommandResponse', resp);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
        deleteMonitoringZone(context, data) {
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'deleteMonitoringZone',
                    plantId: data.plantId,
                    zoneId: data.zoneId,
                    socketId: context.state.socketId,
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    var resp = {
                        pending: false,
                        command: 'deleteMonitoringZone',
                        error: response
                    }
                    Vue.set(context.state, "commandResponse", resp);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        updateZoneLamps(context, data) {
            context.state.loading = true;
            //context.state.bleLogbooks = null;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'updateZoneLamps',
                    plantId: data.plantId,
                    zoneId: data.zoneId,
                    lamps: data.lamps,
                    socketId: context.state.socketId,
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    var resp = {
                        pending: false,
                        command: 'savedLampDescription',
                        response: response
                    }
                    Vue.set(context.state, "commandResponse", resp);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        // deleteBleZone(context, data) {
        //     context.state.loading = true;
        //     Vue.prototype.$axios.post('', {
        //             action: 'deleteBleZone',
        //             plantId: data.plantId,
        //             zoneId: data.zoneId,
        //             socketId: context.state.socketId,
        //         })
        //         .then(function(response) {
        //             console.log("post eseguita", response);
        //             var resp = {
        //                 pending: false,
        //                 command: 'deleteBleZone',
        //                 error: response.data,
        //                 cu: data.plantName,
        //             }
        //             context.commit('setCommandResponse', resp);
        //             context.state.loading = false;
        //         })
        //         .catch(function(error) {
        //             console.log("errore post", error);
        //         });
        // },

        loadAllPlants(context, userId) {
            console.log("invio richiesta All Plants di " + userId)
            context.state.loading = true;
            context.state.error = null;
            context.state.currentPlant = null;
            context.state.plantUnits = null;
            Vue.prototype.$socket.sendObj({ action: 'getAllPlants', data: { userId: userId } });
        },
        loadPlantDetails(context, plantId) {
            console.log("invio richiesta plantDetails=" + plantId)
            context.state.loading = true;
            context.state.error = null;
            context.state.currentPlant = null;
            context.state.plantUnits = null;
            context.state.plantZones = null;
            //context.state.monitoringZones = null; //si ottiene con un altro comando e non va azzerato qui
            //Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: details.plant_id } });
            Vue.prototype.$axios.post('', {
                action: 'getPlantDetails',
                plantId: plantId,
                socketId: context.state.socketId
            }).then(function(response) {
                console.log("arrivato callback post plant details after load plant details", response);
                context.loading = false;
                context.commit('setPlantDetails', response.data)
                    //context.commit('updateUserAllPlants',response.data.data);
            })
            .catch(function(error) {
                console.log("errore post", error);
            });
        },
        //getGlobalReports
        loadGlobalReports(context, plantId) {
            console.log("invio richiesta getGlobalReports su impianto : " + plantId)

            return new Promise((resolve, reject) => {
                //context.state.loading = true;
                //context.state.error = null;
                //Vue.prototype.$socket.sendObj({action:'getLogbookDetails', data:{plantId: plantId}});
                Vue.prototype.$axios.post('', {
                        action: 'getGlobalReports',
                        plantId: plantId,
                        socketId: context.state.socketId
                    }).then(function(response) {
                        console.log("arrivato callback post getGlobalReports", response);
                        //context.loading = false;
                        resolve(response);
                        //context.commit('setGlobalReports', response.data)
                        //context.commit('updateUserAllPlants',response.data.data);
                    })
                    .catch(function(error) {
                        console.log("errore getGlobalReports", error);
                        context.state.error = 'errors.' + error
                        context.state.loading = false;
                        //context.commit('setGlobalReports', null)
                        resolve(error);
                    });
            });


        },
        //-----------------------------------------------------------------------------------
        // Funzione che usa Axios (POST API) per ricevere direttamente i log della Mains
        // Parametri:
        //   context: contesto Vue (this)
        //   parameters: oggetto che contiene i parametri:
        //         {
        //           plantId: 'e05fa9bf-340d-4163-bae0-3bea6dbd2266',
        //           cuId: '00003',
        //           startTime: '1763563470', //timestamp Epoch (in sec)
        //           endTime: '1763863470'
        //         }
        //-----------------------------------------------------------------------------------
        loadMainsLogbooks(context, parameters) {
            console.log("loadMainsLogbooks, parameters: ", parameters);
            context.commit('setLoading', true);
            context.commit('setError', null);
            Vue.prototype.$axios.post('', {
                action: 'getMainsLogs',
                //plantId: parameters.plantId,
                parameters,
                socketId: context.state.socketId
            }).then(function(response) {
                const contentType = response.headers['content-type'];
                console.log("callback contenType:", contentType);
                //mantengo gestione URL S3 per compatibilità futura, nel caso i log diventino troppo grandi
                if (contentType && contentType.startsWith('text/plain')) {
                    //ho ricevuto un URL per scaricare il file da S3
                    //invoco il metodo che si occupa di scaricare il file da S3
                    const fileUrl = response.data;
                    //per ora non implementato!
                    //context.dispatch('logbookDetailsUrl', { data: fileUrl });
                } else {
                    console.log("arrivato callback post MainsLogs", response);
                    context.commit('setLoading', false);
                    context.commit('setMainsLogbooks', response.data)
                }
            }).catch(function(error) {
                console.log("errore logbooksDetails", error);
                context.commit('setError', error);
                context.commit('setLoading', false);
                context.commit('setMainsLogbooks', null)
            });
        },

        loadLogbookDetails(context, plantId) {
            if (context.state.loadingLogbookDetails) {
                console.warn("Richiesta già in corso, ignorata.");
                return;
            }
            console.log("invio richiesta logBookDetails su impianto : " + plantId);
            console.trace("loadLogbookDetails chiamata per impianto:", plantId);
            context.state.loadingLogbookDetails = true,
            context.state.loading = true;
            context.state.error = null;
            context.state.currentLogbooks = null;
            //Vue.prototype.$socket.sendObj({action:'getLogbookDetails', data:{plantId: plantId}});
            Vue.prototype.$axios.post('', {
                action: 'getLogbooksDetails',
                plantId: plantId,
                socketId: context.state.socketId
            }).then(function(response) {
                const contentType = response.headers['content-type'];
                console.log("callback contenType:", contentType);
                if (contentType && contentType.startsWith('text/plain')) {
                    //ho ricevuto un URL per scaricare il file da S3
                    //invoco il metodo che si occupa di scaricare il file da S3
                    const fileUrl = response.data;
                    context.dispatch('logbookDetailsUrl', { data: fileUrl });
                } else {
                    console.log("arrivato callback post logbooks details", response);
                    context.state.loading = false;
                    context.commit('setLogbookDetails', response.data)
                }
            }).catch(function(error) {
                console.log("errore logbooksDetails", error);
                context.state.error = 'errors.' + error
                context.state.loading = false;
                context.commit('setLogbookDetails', null)
            }).finally(() => {
                context.state.loadingLogbookDetails = false;
            });
        },
        //usa websocket per ricevere un URL da dove scaricare i logbook details
        loadLogbookDetailsUrl(context, plantId) {
            console.log("invio richiesta logBookDetails su impianto : " + plantId);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({action:'getLogbookDetails', data:{plantId: plantId}});
        },
        //invocato dal backend per inviare l'URL per scaricare i logbook details
        logbookDetailsUrl(context, msg) {
            // console.log("logbookDetailsUrl parametro: ", msg);
            context.state.loading = true;
            const fileUrl = msg.data;
            console.log("LogbookDetailsUrl", fileUrl);
            Vue.prototype.$axios.get(fileUrl)
                .then((response) => {
                    //axios restituisce un oggetto JSON, che posso assegnare direttamente alla variabile nello stato
                    context.commit('setLogbookDetails', response.data);
                    context.state.loading = false;
                })
                .catch((error) => {
                    console.error("Errore nel download del file:", error);
                    context.state.error = error;
                    context.state.loading = false;
                });
        },

        loadUserDetails(context, userId) {
            console.log("invio richiesta userDetails : " + userId)
            context.state.loading = true;
            context.state.error = null;
            //Vue.prototype.$socket.sendObj({action:'getUserInfos', data:{id:context.state.user.attributes.sub, email:context.state.user.attributes.email}});
            Vue.prototype.$socket.sendObj({ action: 'getUserInfos', data: { id: context.state.user.username, email: context.state.user.email } });
        },
        createSummaryPlants(context, userId) {
            console.log("invio richiesta save summary plants " + userId)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveSummaryPlants', data: { userId: userId } });
        },
        loadPlantCollections(context, plantId) {
            console.log("invio richiesta Collections del Plant " + plantId)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'getCollections', data: { plantId: plantId } });
        },
        _loadPlantZones(context, plantId) {
            console.log("invio richiesta Zones del Plant " + plantId)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'getZones', data: { plantId: plantId } });
        },
        loadPlantScenes(context, plantId) {
            console.log("invio richiesta scenes del Plant " + plantId)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'getScenes', data: { plantId: plantId } });
        },
        acceptInvite(context, extra) {
            console.log("avvio procedura accettazione invito : " + context.state.invite)
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'acceptInvite', data: { invite: context.state.invite, inviteType: context.state.inviteType, nome: context.state.user.name + " " + context.state.user.surname, email: context.state.user.email } });
        },
        getInvitoPendente(context, extra) {
            console.log("avvio procedura verfica presenza invito pendente");
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'checkInvitoPendente', data: { email: context.state.user.email } });
        },
        loadedSummaryJson(context, data) {
            console.log("terminato caricamento del file Json con riepilogo impianti", data);
            //context.state.commandResponse.pending = false;
            var resp = {
                pending: false,
                command: 'loadedSummaryJson',
                response: data.data
            }
            // Vue.set(context.state, "commandResponse", resp);
            this.commit('setCommandResponse', resp);

            //context.state.loading = false;
            this.commit('setLoading', false);
        },
        esitoCheckInvitoPendente(context, data) {
            console.log("ricevuto esitoCheckInvitoPendente", data);
            context.state.commandResponse.pending = false;
            context.state.invite = null;
            context.state.inviteType = null;
            var resp = {
                pending: false,
                command: 'checkInvitoPendente',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        esitoInvito(context, data) {
            console.log("ricevuto esitoInvito", data);
            if (context.state.commandResponse != null) context.state.commandResponse.pending = false;
            context.state.invite = null;
            context.state.inviteType = null;
            var resp = {
                pending: false,
                command: 'acceptInvite',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        plantDetails(context, msg) {
            console.log("ricevuto plantDetails")
            console.log("data", msg.data)
            if (msg.data == undefined) {
                console.log("errore plantDetails")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setPlantDetails', null)
            } else {
                context.commit('setPlantDetails', msg.data)
            }
        },
        plantCollections(context, msg) {
            console.log("ricevuto plantCollections")
            console.log("data", msg.data)
            if (msg.data == undefined) {
                console.log("errore plantCollections")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setPlantCollections', null)
            } else {
                context.commit('setPlantCollections', msg.data)
            }
        },
        plantZones(context, msg) {
            console.log("ricevuto plantZones", msg.data)
            if (msg.data == undefined) {
                console.log("errore plantZones")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setPlantZones', null)
            } else {
                context.commit('setPlantZones', msg.data)
            }
        },
        plantScenes(context, msg) {
            console.log("ricevuto plantScenes", msg.data)
            if (msg.data == undefined) {
                console.log("errore plantScenes")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setPlantScenes', null)
            } else {
                context.commit('setPlantScenes', msg.data)
            }
        },
        logbookDetails(context, msg) {
            console.log("ricevuto logbookDetails")
            console.log("data", msg.data)
            if (msg.data == undefined) {
                console.log("errore logbookDetails")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setLogbookDetails', null)
            } else {
                context.commit('setLogbookDetails', msg.data)
            }
        },
        response(context, msg_response) {
            console.log("ricevuto response di tipo " + msg_response.data.message_type + ", commandsPending:" + context.state.commandsPending, msg_response);
            console.log("elenco comandi inviati:", context.state.commandResponses);
            //qui vengono gestiti i comandi che hanno registrato una response (di norma cmd inviati su WebSocket)
            var resp = context.state.commandResponses[msg_response.data.control_unit];
            //Retry su errore command_not_enabled
            if (resp != null && msg_response.data.message_error == "ERROR_COMMAND_NOT_ENABLED" && resp.retry > 1) {
                console.log("resp=commando not enable retry su ", resp.command, "retry: ", resp.retry);
                var retry_on_error = resp.retry - 1;
                resp.commandInfo.retry = retry_on_error;
                resp.timeout = 5;
                clearTimeout(resp.timeoutId);
                context.state.commandsPending = context.state.commandsPending - 1;

                setTimeout(function() {
                    if (resp.commandInfo.cu_type == 'logica') {
                        context.dispatch('sendLogicaCommand', resp.commandInfo);
                    } else {
                        context.dispatch('sendCablecomCommand', resp.commandInfo);
                    }
                }, 1000);
                return;
            }

            console.log("resp=", resp);
            if (resp != null) {
                clearTimeout(resp.timeoutId);
                resp.pending = false;
                resp.cu = msg_response.data.control_unit;
                resp.type = msg_response.data.type;
                resp.command = msg_response.data.message_command;
                resp.error = msg_response.data.message_error;
                resp.response = msg_response.data.message_attribute;
                context.commit('setCommandResponse', resp);
                context.commit('setCommandsPending', context.state.commandsPending - 1);
                context.commit('setLoading', context.state.commandsPending > 0);

                if (resp.commandInfo && resp.commandInfo.responseCallback != null) {
                    console.log("questo comando è una promise! ");
                    resp.commandInfo.responseCallback(resp);
                }
            } else {
                //qui si gestiscono i cmd che hanno registrato una Promise (di norma cmd inviati su WebSocket che non è asincrona)
                const commandId = msg_response.data.control_unit;
                const pendingEntry = context.state.pendingCommands[commandId];

                if (pendingEntry) {
                    // Destructure the stored timeoutId
                    const { resolve, reject, timeoutId } = pendingEntry;

                    console.log("Trovata promise pendente per il comando ", commandId, ", risolvo/rejetto la promise: ", pendingEntry);
                    // CRITICAL STEP 1: Stop the client-side timeout timer immediately
                    if (timeoutId) clearTimeout(timeoutId);

                    if (msg_response.data.message_error) {
                        reject(new Error(msg_response.data.message_error || 'Command failed'));
                    } else {
                        //resolve the promise in the calling component
                        resolve(msg_response.data);
                        //resolve('ok');
                    }
                    // CRITICAL STEP 2: Remove the entry to clean up memory
                    delete context.state.pendingCommands[commandId];
                }
            }
        },

        keepalive(context, msg) {
            console.log("ricevuto keepalive:", msg)
            let centId = msg.data.control_unit
            let event = msg.data.message_event
                //trovo la centrale
            if (context.state.plantUnits != null) {
                //console.log("cerco centrale " + centId)
                let cent = context.state.plantUnits.find(function(c) {
                    //console.log("verifico",c);
                    if (c.cu_id == centId) return c;
                    return null;
                });
                //console.log("cent=",cent);
                if (cent != null) {
                    let connected = (event == "connected")
                        //console.log("actual " + cent.cu_connected+", new:" + connected)
                    cent.cu_connected = connected
                }
            }
        },
        // shadow(context, msg) {
        //     console.log("ricevuta shadow", msg)
        //     let cent = msg.data.Item;
        //     let cu_id = cent.cu_id;
        //     let cu_type = cent.cu_type;
        //     if (context.state.plantUnits != null) {
        //         cent.working = false;
        //         for (var i = 0; i < context.state.plantUnits.length; i++) {
        //             let c = context.state.plantUnits[i];

        //             if (c.cu_id == cu_id && c.cu_type == cu_type) {
        //                 //context.state.plantUnits[i].cu_error.error_missing_lamp_in_config = cent.cu_error.error_missing_lamp_in_config
        //                 //Object.assign(c,cent)
        //                 //console.log("aggiornata centrale " + i + "- " + cu_id, cent)
        //                 //break
        //                 //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
        //                 Vue.prototype.$axios.post('', {
        //                         action: 'getShadow',
        //                         cuId: cu_id,
        //                         cuType: cu_type,
        //                         socketId: context.state.socketId
        //                     })
        //                     .then(function(response) {
        //                         cent = response.data;
        //                         console.log("aggiornata centrale " + i + "- " + cu_id + " " + cu_type, cent);
        //                         //console.log("post eseguita",response);
        //                         c.working = false;
        //                         Object.assign(c, cent);
        //                         //context.commit('updateUserAllPlants',response.data.data);
        //                         cent.working = false;
        //                     })
        //                     .catch(function(error) {
        //                         console.log("errore post", error);
        //                     });
        //                 //break;
        //             }
        //         }
        //     }
        // },
        shadow(context, msg) {
            console.log("ricevuta shadow", msg)
            let cent = msg.data.Item;
            let cu_id = cent.cu_id;
            let cu_type = cent.cu_type;
            let plants = context.state.plantUnits;
            if (plants != null) {
                cent.working = false;
                for (var i = 0; i < plants.length; i++) {
                    let c = plants[i];

                    if (c.cu_id == cu_id && c.cu_type == cu_type) {
                        //context.state.plantUnits[i].cu_error.error_missing_lamp_in_config = cent.cu_error.error_missing_lamp_in_config
                        //Object.assign(c,cent)
                        //console.log("aggiornata centrale " + i + "- " + cu_id, cent)
                        //break
                        //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
                        Vue.prototype.$axios.post('', {
                                action: 'getShadow',
                                cuId: cu_id,
                                cuType: cu_type,
                                socketId: context.state.socketId
                            })
                            .then(function(response) {
                                cent = response.data;
                                console.log("aggiornata centrale " + i + "- " + cu_id + " " + cu_type + " old: ", c , cent);
                                c.working = false;
                                Object.assign(c, cent);
                                //context.commit('updateUserAllPlants',response.data.data);
                                cent.working = false;
                                //context.commit('updatePlantUnits', plants);
                                context.commit('setUnitsDetails',plants);
                            })
                            .catch(function(error) {
                                console.log("errore post", error);
                            });
                        //break;
                    }
                }
                // context.commit('updatePlantUnits', plants);
            }
        },
        loadUnitsDetails(context, plantId) {
            context.state.loading = true;
            context.state.error = null;
            context.state.plantUnits = null;
            //Vue.prototype.$socket.sendObj({action:'getUnitsDetails', data:{plantId: plantId}});
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getUnitsDetails',
                    plantId: plantId,
                    socketId: context.state.socketId
                }).then(function(response) {
                    console.log("arrivato callback post unit details", response);
                    context.loading = false;
                    context.commit('setUnitsDetails', response.data)
                        //context.commit('updateUserAllPlants',response.data.data);
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
        dbSaveProfile(context, profileInfo) {
            console.log("Salvo i dati di installatore o cliente", profileInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveProfile', data: { profileInfo: profileInfo } });
        },
        dbSaveNotificationsOnProfile(context, notificationsInfo) {
            console.log("Salvo le impostazioni di notifica", notificationsInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveNotificationsOnProfile', data: { notificationsInfo: notificationsInfo } });
        },
        dbSaveMarketing(context, marketingInfo) {
            console.log("Salvo i consensi di marketing", marketingInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveMarketing', data: { marketingInfo: marketingInfo } });
        },
        dbSaveNomina(context, nominaInfo) {
            console.log("Salvo accettazione nomina");
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveNomina', data: { nominaInfo: nominaInfo } });
        },
        dbSaveDisclaimerPhoto(context, disclaimerPhotoInfo) {
            console.log("Salvo disclaimer photo");
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveDisclaimerPhoto', data: { disclaimerPhotoInfo: disclaimerPhotoInfo } });
        },
        dbSaveLampDescription(context, lampDescInfo) {
            console.log("Salvo il descrittivo cloud di lampada", lampDescInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveLampDescription', data: { lampDescInfo: lampDescInfo } });
        },
        importLampDescr(context, lampDescInfo) {
            console.log("Importo i descrittivi di lampada da file", lampDescInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'importLampDescription', data: { lampDescInfo: lampDescInfo } });
        },
        dbSaveCuDescription(context, cuDesc) {
            console.log("Salvo il descrittivo cloud di centrale", cuDesc);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveCuDescription', data: { cuDesc: cuDesc } });
        },
        dbSaveGroup(context, groupInfo) {
            console.log("Salvo i dati del gruppo creato ", groupInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveGroup', data: { groupInfo: groupInfo } });
        },
        dbSaveCollection(context, collectionInfo) {
            console.log("Salvo i dati della aggregazione creata ", collectionInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveCollection', data: { collectionInfo: collectionInfo } });
        },
        dbUpdateCollection(context, collectionInfo) {
            console.log("Aggiorno i dati della aggregazione ", collectionInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateCollection', data: { collectionInfo: collectionInfo } });
        },
        dbRemoveCollection(context, collectionInfo) {
            console.log("Rimuovo l'aggregazione dal db", collectionInfo);
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'removeCollection', data: { collectionInfo: collectionInfo } });
        },
        dbSaveZone(context, zoneInfo) {
            console.log("Salvo i dati della zona creata ", zoneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveZone', data: { zoneInfo: zoneInfo } });
        },
        /*dbSaveMonitoringZone(context, zoneInfo) {
            console.log("Salvo i dati della zona di monitoraggio creata ", zoneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveMonitoringZone', data: { zoneInfo: zoneInfo } });
        },*/
        dbSaveScene(context, sceneInfo) {
            console.log("Salvo i dati della scena creata ", sceneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveScene', data: { sceneInfo: sceneInfo } });
        },
        dbUpdateZone(context, zoneInfo) {
            console.log("Aggiorno i dati della zona ", zoneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateZone', data: { zoneInfo: zoneInfo } });
        },
        dbUpdateZoneEnergyLamps(context, zoneInfo) {
            console.log("Aggiorno le lampade nella zona di monitoraggio ", zoneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateZoneEnergyLamps', data: { zoneInfo: zoneInfo } });
        },
        dbUpdateScene(context, sceneInfo) {
            console.log("Aggiorno i dati della scena ", sceneInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateScene', data: { sceneInfo: sceneInfo } });
        },
        dbRemoveZone(context, zoneInfo) {
            console.log("Rimuovo la zona dal db", zoneInfo);
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'removeZone', data: { zoneInfo: zoneInfo } });
        },
        dbRemoveScene(context, sceneInfo) {
            console.log("Rimuovo la scena dal db", sceneInfo);
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'removeScene', data: { sceneInfo: sceneInfo } });
        },
        dbUpdateQrLamps(context, qrLampInfos) {
            console.log("Aggiorno i dati delle lampade qr ", qrLampInfos);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateCentQrLamps', data: { qrLampInfos: qrLampInfos } });
        },
        dbSavePlant(context, plantInfo) {
            console.log("Salvo i dati di impianto", plantInfo);
            context.state.loading = true;
            context.state.error = null;
            if (plantInfo.create === true) {
                //azzero i dati di impianto attualmente selezionato
                //context.state.userLastPlants = [];
                //context.state.userAllPlants = [];
                context.state.currentPlant = null;
                context.state.currentLogbooks = null;
                context.state.plantUnits = null;


            }
            Vue.prototype.$socket.sendObj({ action: 'savePlant', data: { plantInfo: plantInfo } });
        },
        dbUpdatePlant(context, plantInfo) {
            console.log("Aggiorno i dati di impianto", plantInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updatePlant', data: { plantInfo: plantInfo } });
        },
        dbUpdateProductCode(context, lampInfo) {
            console.log("Aggiorno i dati di prodotto per lampade non tipizzate", lampInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'updateProductCode', data: { lampInfo: lampInfo } });
        },
        dbSaveCu(context, cuInfo) {
            console.log("Salvo una nuova cu in db", cuInfo);
            context.state.loading = true;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'saveCu', data: { cuInfo: cuInfo } });
        },
        dbRemoveCu(context, cuData) {
            console.log("Rimuovo la cu dal db", cuData);
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'removeCu', data: { cuInfo: cuData } });
        },
        enrollCu(context, cuInfo) {
            console.log("Invio dati di enrollment", cuInfo);

            var resp = {
                pending: true,
                command: "enroll",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };
            context.state.commandResponses[cuInfo.serial] = resp;

            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "enroll";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'enrollCu', data: { cuInfo: cuInfo } });
        },
        enrollCuAck(context, cuInfo) {
            console.log("Invio ack enroll", cuInfo);

            var resp = {
                pending: true,
                command: "enrollack",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };
            context.state.commandResponses[cuInfo.serial] = resp;

            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "enrollack";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'enrollCuAck', data: { cuInfo: cuInfo } });
        },
        deEnrollCu(context, cuInfo) {
            console.log("Invio de enroll", cuInfo);

            var resp = {
                pending: true,
                command: "deenroll",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };
            context.state.commandResponses[cuInfo.serial] = resp;


            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "deenroll";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'deEnrollCu', data: { cuInfo: cuInfo } });
        },
        resetCu(context, cuInfo) {
            console.log("Invio reset", cuInfo);

            var resp = {
                pending: true,
                command: "reset",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };
            context.state.commandResponses[cuInfo.serial] = resp;


            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "reset";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'resetCu', data: { cuInfo: cuInfo, topic: cuInfo.type + "_" + cuInfo.serial } });
        },
        keypressSimulation(context, cuInfo) {
            console.log("KeyPress Simulation", cuInfo);
            Vue.prototype.$socket.sendObj({ action: 'keypressSimulation', data: { cuInfo: cuInfo, topic: cuInfo.type + "_" + cuInfo.serial } });
        },

        //------------------------------------------------------------------------------------------
        // Funzione che setta il loading e di conseguenza attiva il componente Loader.vue
        //
        //------------------------------------------------------------------------------------------
        attivaLoading(context) {
            context.commit('setCommandsPending', context.state.commandsPending + 1);
            context.commit('setLoading', context.state.commandsPending > 0);
        },
        //------------------------------------------------------------------------------------------
        // Funzione che, eventualmente, disattiva il loading e di conseguenza il componente Loader.vue
        //
        //------------------------------------------------------------------------------------------
        disattivaLoading(context) {
            context.commit('setCommandsPending', context.state.commandsPending - 1);
            context.commit('setLoading', context.state.commandsPending > 0);
        },

        //------------------------------------------------------------------------------------------
        // Funzione che invia un comando ad un Gateway
        // Parametri: cuInfo = { action: <nome_cmd>, payload: { cuid, cutype, plant, lampstype } }
        //------------------------------------------------------------------------------------------
        async sendGatewayCommand(context, cmdData) {
            console.log("Invio a gateway il comando: ", cmdData);
            const MAX_RETRIES = 3;
            const cmd = cmdData.action;
            const dataCmd = cmdData.payload;
            const wsPayload = {
                action: cmd,
                data: { cuInfo: dataCmd,
                        topic: dataCmd.cutype + "_" + dataCmd.cuid,
                        addr_type: dataCmd.addr_type,
                        addr_zone: dataCmd.addr_zone,
                        addr_group:dataCmd.addr_group,
                        addr_lamp:dataCmd.addr_lamp
                     }
            }

            // Outer loop manages retry count
            for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
                try {
                    // Await the current sending attempt
                    const result = await createCommandPromise(context, {
                        cuid: dataCmd.cuid,
                        wsPayload: wsPayload,
                        timeout: 3000
                    });
                    // If successful, return the result and break the loop
                    return result;

                } catch (error) {
                    console.error(`Attempt ${attempt} failed: ${error.message}`);
                    // If it's the last attempt, throw the error to halt the entire sequence
                    if (attempt === MAX_RETRIES) {
                        context.commit('setCommandResponse', { command: wsPayload.action, cu: dataCmd.cuid, pending: false, response: null, error: error.message});
                        throw new Error(`Command ${wsPayload.action} failed after ${MAX_RETRIES} retries.`);
                    }
                }
            }
        },

        //------------------------------------------------------------------------------------------
        // Funzione che salva la configurazione del gateway
        // context: store context
        // data: oggetto con i parametri necessari al salvataggio: gatewayId, plantId, gatewayZones
        //------------------------------------------------------------------------------------------
        async saveGatewayConfiguration(context, data) {
            console.log("Invio saveGatewayConfiguration", data);
            var resp = {
                pending: true,
                command: "saveGatewayConfiguration",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };

            var params = {
              "action":"saveGatewayConfiguration",
              "socketId": context.state.socketId,
              "gatewayId": data.gatewayId,
              "plantId": data.plantId,
              "gatewayZones": data.gatewayZones
            };
            context.commit('setLoading', true);

            Vue.prototype.$axios.post('', params)
            .then(function(response) {
                console.log("arrivato callback post saveGatewayConfiguration", response);
                if (response.data.message_error) {
                    throw new Error(response.data.message_error || 'Configuration has failed');
                }
                //imponiamo la modifica di commandResponse
                console.log("response: ", response);
                resp.pending = false;
                resp.cu = response.data.control_unit;
                resp.type = data.cuType;
                resp.command = response.data.message_command;
                resp.error = response.data.message_error;
                resp.response = response.data.message_attribute;
                context.commit('setCommandResponse', resp);
                context.commit('setLoading', false);
                // context.commit('setCommandsPending', context.state.commandsPending - 1);
                // Resolve the Promise with the server response
                return response.data;
            })
            .catch(error => {
                // Re-throw the error so it can be caught by the calling component's try/catch
                console.error("Errore durante saveGatewayConfiguration:", error);
                throw error;
            })
        },

        unitsDetails(context, msg) {
            console.log("ricevuto unitsDetails", msg)
            if (msg.data == undefined) {
                console.log("errore unitsDetails")
                context.state.error = 'errors.' + msg.error
                context.state.loading = false;
                context.commit('setUnitsDetails', null)
            } else {
                context.commit('setUnitsDetails', msg.data)
            }
        },
        savedPlant(context, msg) {
            console.log("ricevuto savedPlant", msg)
            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0); //false;
            if (msg.data != false) {
                console.log("impianto salvato")
                    //La navbar viene portata sul nuovo impianto creato
                context.state.userLastPlants.unshift(msg.data);
                router.push({ name: 'HomeImpianto', params: { pid: msg.data.id } })
            } else {
                console.log("errore in salvataggio impianto in db")
            }
        },
        updatedPlant(context, msg) {
            console.log("ricevuto updatedPlant", msg, context.state.currentPlant);
            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0); //false;
            if (msg.data != false) {
                console.log("impianto aggiornato")
                    //context.state.userLastPlants.shift();
                    //context.state.userLastPlants.unshift(msg.data);
                var p = msg.data.plantInfo;
                var pdata = { plantname: p.name, id: p.id, address: { country: p.country, housenumber: p.number, city: p.city, street: p.street, prov: p.prov, cap: p.cap, lat: p.lat, long: p.long } }
                Vue.set(context.state.userLastPlants, 0, pdata);

                context.state.currentPlant.plantname = p.name;
                context.state.currentPlant.address = { country: p.country, housenumber: p.number, city: p.city, street: p.street, prov: p.prov, cap: p.cap, lat: p.lat, long: p.long };

                //La navbar viene portata sul nuovo impianto creato
                // Vue.prototype.$socket.sendObj({action:'getUserInfos', data:{id:context.state.user.attributes.sub, email:context.state.user.attributes.email}});
            } else {
                console.log("errore in salvataggio impianto in db")
            }
        },
        updatedProductCode(context, msg) {
            console.log("ricevuto updatedProductCode", msg);
            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0); //false;
            if (msg.data != false) {
                console.log("aggiornati dati delle lampade by user",msg);
            } else {
                console.log("errore in salvataggio in db");
            }
            var resp = {
                pending: false,
                command: 'updatedProduct',
                response: msg
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        savedProfile(context, msg) {
            console.log("ricevuto savedProfile, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                context.state.user.attributes.usertype = msg.data;
                Vue.set(context.state.user, "usertype", msg.data);
                console.log("profilo salvato", context.state.user);
                data = context.state.user
            } else {
                console.log("errore in salvataggio profilo in db")
            }
            var resp = {
                pending: false,
                command: 'saveProfile',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },

        savedNotificationsProfile(context, msg) {
            console.log("ricevuto savedNotificationsProfile", msg.data);
            var resp = {
                pending: false,
                command: 'saveNotificationsOnProfile',
                response: msg
            }
            context.state.currentPlant.plantUsers = msg.data;
            Vue.set(context.state.currentPlant, "plantUsers", msg.data);
            console.log("profilo notifiche utente salvato", context.state.currentPlant);
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        savedLampDescription(context, msg) {
            console.log("ricevuto savedLampDescription, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("descrizione lampada salvata",data);
            } else {
                console.log("errore in salvataggio descrizione lampada in db")
            }

            if (context.state.commandResponse != null && context.state.commandResponse.command == 'asyncDbSaveLampDescription') {
                var resp = context.state.commandResponse;
                resp.pending = false;
                resp.response = msg.data;
                resp.error = msg.data.error;
                if (resp.responseCallback != null) {
                    console.log("completo promise nome lampada!");
                    resp.responseCallback(resp);
                    return;
                }
            }

            var resp = {
                pending: false,
                command: 'savedLampDescription',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;

        },
        importedLampDescriptions(context, msg) {
            console.log("ricevuto importedLampDescriptions, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                console.log("descrizione lampada salvata");
            } else {
                console.log("errore in salvataggio descrizione lampada in db")
            }

            /*if (context.state.commandResponse != null && context.state.commandResponse.command == 'asyncDbSaveLampDescription') {
                var resp = context.state.commandResponse;
                resp.pending = false;
                resp.response = msg.data;
                resp.error = msg.data.error;
                if (resp.responseCallback != null) {
                    console.log("completo promise nome lampada!");
                    resp.responseCallback(resp);
                    return;
                }
            }*/

            var resp = {
                pending: false,
                command: 'importedLampDescriptions',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;

        },
        savedMarketing(context, msg) {
            console.log("ricevuto savedMarketing", msg)
            var data = "";
            if (msg.data != false) {
                Vue.set(context.state.user, "marketing", msg.data.marketing);
                Vue.set(context.state.user, "profiling", msg.data.profiling);
                Vue.set(context.state.user, "thirdparts", msg.data.thirdparts);
                data = context.state.user
            } else {
                console.log("errore in salvataggio marketing in db")
            }
            var resp = {
                pending: false,
                command: 'saveMarketing',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        nominaAccepted(context, msg) {
            console.log("ricevuto nomina Accepted", msg)
            if (msg.data != false) {
                console.log("nomina accettata");
                var resp = {
                    pending: false,
                    command: 'nominaAccepted',
                    response: msg.data
                }
                Vue.set(context.state, "commandResponse", resp);
            } else {
                console.log("errore in salvataggio accettazione nomina")
            }
        },
        disclaimerPhotoAccepted(context, msg) {
            console.log("ricevuto disclaimer photo Accepted", msg)
            if (msg.data != false) {
                console.log("disclaimer photo accettata");
                var resp = {
                    pending: false,
                    command: 'disclaimerPhotoAccepted',
                    response: msg.data
                }
                Vue.set(context.state, "commandResponse", resp);
            } else {
                console.log("errore in salvataggio accettazione nomina")
            }
        },
        savedCollection(context, msg) {
            console.log("ricevuto savedCollection, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Collection salvata", data);
            } else {
                console.log("errore salvataggio collection in db")
            }
            var resp = {
                pending: false,
                command: 'saveCollection',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        updatedCollection(context, msg) {
            console.log("ricevuto updatedCollection, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Collection salvata", data);
            } else {
                console.log("errore salvataggio collection in db")
            }
            var resp = {
                pending: false,
                command: 'updateCollection',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        removedCollection(context, msg) {
            console.log("ricevuto removedCollection, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Collection eliminata", data);
            } else {
                console.log("errore rimozione collection in db")
            }
            var resp = {
                pending: false,
                command: 'removeCollection',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        updatedCentQrLamps(context, msg) {
            console.log("ricevuto updatedCentQrLamps, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
            } else {
                console.log("errore salvataggio updatedCentQrLamps in db")
            }
            var resp = {
                pending: false,
                command: 'updatedCentQrLamps',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        savedZone(context, msg) {
            console.log("ricevuto savedZone, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Zone salvata", data);
            } else {
                console.log("errore salvataggio zone in db")
            }
            var resp = {
                pending: false,
                command: 'saveZone',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        /*savedMonitoringZone(context, msg) {
            console.log("ricevuto savedMonitoringZone, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Monitoring Zone salvata", data);
            } else {
                console.log("errore salvataggio monitoring zone in db")
            }
            var resp = {
                pending: false,
                command: 'saveMonitoringZone',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },*/
        savedScene(context, msg) {
            console.log("ricevuto savedScene, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Scene salvata", data);
            } else {
                console.log("errore salvataggio scene in db")
            }
            var resp = {
                pending: false,
                command: 'saveScene',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        updatedZone(context, msg) {
            console.log("ricevuto updatedZone, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Zone salvata", data);
            } else {
                console.log("errore salvataggio zone in db")
            }
            var resp = {
                pending: false,
                command: 'updateZone',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        updatedScene(context, msg) {
            console.log("ricevuto updatedScene, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Scene salvata", data);
            } else {
                console.log("errore salvataggio scene in db")
            }
            var resp = {
                pending: false,
                command: 'updateScene',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        removedZone(context, msg) {
            console.log("ricevuto removedZone, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            var resp = {
                pending: false,
                command: 'removeZone',
                response: ""
            }
            if (msg.data != false) {
                resp.data = msg.data;
                resp.cu = msg.data.zoneInfo.plantName;
                console.log("Zone eliminata", data);
            } else {
                console.log("errore rimozione zone in db");
                resp.error = msg.error;
                resp.cu = "";
            }
            //Vue.set(context.state, "commandResponse", resp);
            context.commit('setCommandResponse', resp);
            context.state.loading = false;
        },
        removedScene(context, msg) {
            console.log("ricevuto removedScene, commands pending = " + context.state.commandsPending, msg)
            var data = "";
            if (msg.data != false) {
                data = msg.data;
                console.log("Scene eliminata", data);
            } else {
                console.log("errore rimozione scene in db")
            }
            var resp = {
                pending: false,
                command: 'removeScene',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
            context.state.loading = false;
        },
        sendTestFunz(context, cuInfo) {
            console.log("Invio comando test funzionale", cuInfo);
            context.state.loading = true;
            context.state.error = null;
            context.state.commandsPending += 1;

            var resp = {
                pending: true,
                command: "sendTestFunz",
                response: null,
                error: null,
                cu: null,
                timeout: 5,
                retry: 0,
                timeoutId: null
            };
            context.state.commandResponses[cuInfo.cu_id] = resp;


            context.state.commandResponse.retry = 0;

            if (resp.timeout > 0) {
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    context.commit('checkCommandTimeout', cuInfo.cu_id);
                    var retryAgain = resp.retry;
                    if (retryAgain > 0) {
                        console.log("ripeto il comando sendTestFunz")
                        resp.retry = resp.retry - 1;
                        context.state.commandsPending -= 1;
                        context.dispatch('sendTestFunz', cuInfo);
                    }
                }, resp.timeout * 1000);
            }

            Vue.prototype.$socket.sendObj({ action: 'ftest', data: { topic: cuInfo.cu_type + "_" + cuInfo.cu_id, addr: cuInfo.addr } });
        },
        sendCablecomCommand(context, commandInfo) {
            console.log("Invio comando ", commandInfo);
            context.state.loading = true;
            context.state.error = null;

            var resp = null;

            if (!commandInfo.retry) {
                context.state.commandResponse.retry = 3;
                var cmd = commandInfo.cu_command.command || commandInfo.cu_command;

                console.log("è il primo comando cablecom cmd=" + cmd);

                resp = {
                    pending: true,
                    command: cmd,
                    response: null,
                    error: null,
                    cu: commandInfo.cu_id,
                    timeout: 5,
                    retry: 3,
                    timeoutId: null,
                    commandInfo: commandInfo
                };
            } else {
                resp = {
                    pending: true,
                    command: commandInfo.cu_command,
                    response: null,
                    error: null,
                    cu: commandInfo.cu_id,
                    timeout: 5,
                    retry: commandInfo.retry,
                    timeoutId: null,
                    commandInfo: commandInfo
                };
                console.log("resp on error", resp);
            }
            context.state.commandResponses[commandInfo.cu_id] = resp;


            let cent = context.state.plantUnits.find(function(c) {
                if (c.cu_id == commandInfo.cu_id) return c;
                return null;
            });
            if (cent != null) {
                if (resp.commandInfo.cu_command != "stop_blink" && (resp.commandInfo.cu_command != "refresh")) {
                    cent["working"] = true
                }
                console.log("aggiornato working su " + cent.cu_id, cent, resp.commandInfo.cu_command);
                setTimeout(function() {
                    if (cent != null && cent != undefined) cent["working"] = false
                }, 35000);
            }
            context.state.commandsPending = Math.max(1, context.state.commandsPending + 1);

            if (resp.timeout > 0) {
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    // context.commit('checkCommandTimeout', commandInfo.cu_id);
                    var retryAgain = resp.retry;
                    context.state.commandsPending = context.state.commandsPending - 1;
                    console.log("ripeto retry again", retryAgain);
                    if (retryAgain > 1) {
                        console.log("ripeto il comando sendCablecomCommand", commandInfo);
                        resp.retry = resp.retry - 1;
                        context.state.commandsPending -= 1;
                        commandInfo.retry = resp.retry;
                        context.dispatch('sendCablecomCommand', commandInfo);
                    } else {
                        console.log("non ripeto il comando", commandInfo);
                        cent["working"] = false;
                        context.state.loading = (context.state.commandsPending > 0);
                        resp.error = 'communication_error';
                        resp.pending = false;
                        context.commit('setCommandResponse', resp);
                        //context.state.error = { tipo:'config_cu_modal.error', par:resp.cu };
                    }
                }, resp.timeout * 1000);
            }
            if (commandInfo.cu_type === 'blegateway' && (cmd == 'setDateTimeFunzionale' || cmd == 'setDateTimeAutonomia' || cmd == 'setPeriodAutonomia' || cmd == 'setPeriodFunzionale'))
            {

                //convert in Iso String Date
                if(commandInfo.cu_command.set_functional!='')
                {
                    var dataFunz= new Date(commandInfo.cu_command.set_functional);
                    commandInfo.cu_command.set_functional=dataFunz.toLocaleString();
                }

                if(commandInfo.cu_command.set_autonomy!='')
                {
                    var dataAuton= new Date(commandInfo.cu_command.set_autonomy);
                    commandInfo.cu_command.set_autonomy=dataAuton.toLocaleString();
                }

                console.log("scheduling : ", commandInfo);
                Vue.prototype.$socket.sendObj({ action: "gatewaySchedulingTest", data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id , param:commandInfo.cu_command }});
            }
            else if (commandInfo.cu_command.command == "setMultiParam")
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { cu_type: commandInfo.cu_type, topic: commandInfo.cu_type + "_" + commandInfo.cu_id, indexes: commandInfo.indexes, autonomy: commandInfo.cu_command.autonomy, parity: commandInfo.cu_command.parity, infinity: commandInfo.cu_command.infinity, mode: commandInfo.cu_command.mode, opticom: commandInfo.cu_command.opticom, durataTest: commandInfo.cu_command.durataTest, uvOxyOnOff: commandInfo.cu_command.uvOxyOnOff, uvOxyTimer: commandInfo.cu_command.uvOxyTimer, uvOxyFanSpeed: commandInfo.cu_command.uvOxyFanSpeed } });
            else if (commandInfo.cu_command.command == "setParam")
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, addr: commandInfo.addr, autonomy: commandInfo.cu_command.autonomy, parity: commandInfo.cu_command.parity, infinity: commandInfo.cu_command.infinity, mode: commandInfo.cu_command.mode } });
            else if (commandInfo.cu_command.command == "setGroup")
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, indexes: commandInfo.indexes, group: commandInfo.cu_command.groupNumber } });
            else if (commandInfo.cu_command.command == "removeGroup")
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, indexes: commandInfo.indexes, group: commandInfo.cu_command.groupNumber } });
            else if (commandInfo.cu_command == 'setCuName') {
                console.log("invio cmd con action: ", commandInfo.cu_command + " e data.topic: ", commandInfo.cu_type + "_" + commandInfo.cu_id + " e data.cuName: ", commandInfo.cuName);
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, cuName: commandInfo.cuName } });
            } else if (commandInfo.cu_command == 'setLampName')
                Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, lampName: commandInfo.lampName, lampIndex: commandInfo.lampIndex, lampId: commandInfo.lampId } });
            else if (cmd == 'setDateTimeFunzionale') {
                console.log("invio cmd setDateTimeFunzionale", commandInfo.cu_command.set_functional, commandInfo.cu_type + "_" + commandInfo.cu_id);
                if ((commandInfo.cu_type === 'logicafm') || (commandInfo.cu_type === 'sicuro')) {
                    //Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setFunzionale: commandInfo.cu_command.set_functional } });
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id } });
                } else {
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setFunzionale: commandInfo.cu_command.set_functional } });
                }
            } else if (cmd == 'setDateTimeAutonomia') {
                console.log("invio cmd setDateTimeAutonomia", commandInfo.cu_command.set_autonomy, commandInfo.cu_type + "_" + commandInfo.cu_id);
                if ((commandInfo.cu_type === 'logicafm') || (commandInfo.cu_type === 'sicuro') ) {
                    // Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setAutonomia: commandInfo.cu_command.set_autonomy } });
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id } });
                } else {
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setAutonomia: commandInfo.cu_command.set_autonomy } });
                }
            } else if (cmd == 'setPeriodAutonomia') {
                console.log("invio cmd setPeriodicitàAutonomia", commandInfo.cu_command.period_autonomy, commandInfo.cu_type + "_" + commandInfo.cu_id);
                Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, periodAutonomia: commandInfo.cu_command.period_autonomy, differito: commandInfo.cu_command.differito } });
            } else if (cmd == 'setPeriodFunzionale') {
                console.log("invio cmd setPeriodicitàFunzionale", commandInfo.cu_command.period_functional, commandInfo.cu_type + "_" + commandInfo.cu_id);
                Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, periodFunzionale: commandInfo.cu_command.period_functional } });
            }
            else
            {
                if (commandInfo.cu_type === 'blegateway')
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, addr_type: commandInfo.addr_type, addr_zone:commandInfo.addr_zone, addr_group:commandInfo.addr_group, addr_lamp:commandInfo.addr_lamp, command:commandInfo.param } });
                else
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, addr: commandInfo.addr } });
            }
        },

        //funzione che invia comandi per Centrali Sicuro
        sendSicuroCommand(context, commandInfo) {
            console.log("Invio comando sicuro ", commandInfo);
            context.state.loading = true;
            context.state.error = null;

            var resp = null;

            //Gestione dei retry
            //se non è stato passato il retry, lo imposto a 3
            //se è stato passato il retry, lo uso come valore di partenza
            //in entrambi i casi, se il retry arriva a 0, non viene più ripetuto il comando
            console.log("sendSicuroCommand, commandInfo: ", commandInfo);
            if (!commandInfo.retry) {
                context.state.commandResponse.retry = 3;
                var cmd = commandInfo.command.command;

                console.log("è il primo comando sicuro cmd=" + cmd);

                resp = {
                    pending: true,
                    command: cmd,
                    response: null,
                    error: null,
                    cu: commandInfo.cu_id,
                    timeout: 12, //timeout prolungato a 12 secondi per i comandi sicuro
                    retry: 3,
                    timeoutId: null,
                    commandInfo: commandInfo
                };
            } else {
                resp = {
                    pending: true,
                    command: commandInfo.command.command,
                    response: null,
                    error: null,
                    cu: commandInfo.cu_id,
                    timeout: 12,
                    retry: commandInfo.retry,
                    timeoutId: null,
                    commandInfo: commandInfo
                };
                console.log("resp on error", resp);
            }
            //Aggiungo la risposta del comando all'array delle risposte dei comandi
            context.state.commandResponses[commandInfo.cu_id] = resp;

            //verifico che la Centrale sia presente nell'impianto
            let cent = context.state.plantUnits.find(function(c) {
                console.log("sendSicuroCommand, centrale: " + c.cu_id + " current");
                if (c.cu_id == commandInfo.cu_id) return c;
                return null;
            });
            console.log("sendSicuroCommand, centrale: ", cent);
            //Se la centrale è presente, imposto il working a true
            //e imposto un timeout per riportarlo a false dopo 35 secondi
            if (cent != null) {
                if (resp.commandInfo.command != "stop_blink" && (resp.commandInfo.command != "refresh")) {
                    cent["working"] = true
                }
                console.log("aggiornato working su " + cent.cu_id, cent, resp.commandInfo.cu_command);
                setTimeout(function() {
                    if (cent != null && cent != undefined) cent["working"] = false
                }, 35000);
            }
            //Incremento il numero di comandi in attesa
            context.state.commandsPending = Math.max(1, context.state.commandsPending + 1);

            //gestisco il timeout del comando
            //se il timeout è maggiore di 0, imposto un setTimeout per gestire il timeout del comando
            //se il comando non risponde entro il timeout, viene ripetuto il comando se il retry è maggiore di 0
            //altrimenti viene segnalato un errore di comunicazione
            if (resp.timeout > 0) {
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    var retryAgain = resp.retry;
                    context.state.commandsPending = context.state.commandsPending - 1;
                    console.log("ripeto retry again", retryAgain);
                    if (retryAgain > 1) {
                        console.log("ripeto il comando sendCablecomCommand", commandInfo);
                        resp.retry = resp.retry - 1;
                        context.state.commandsPending -= 1;
                        commandInfo.retry = resp.retry;
                        context.dispatch('sendSicuroCommand', commandInfo);
                    } else {
                        console.log("non ripeto il comando", commandInfo);
                        cent["working"] = false;
                        context.state.loading = (context.state.commandsPending > 0);
                        resp.error = 'communication_error';
                        resp.pending = false;
                        context.commit('setCommandResponse', resp);
                    }
                }, resp.timeout * 1000);
            }
            Vue.prototype.$socket.sendObj({ action: commandInfo.command , data: commandInfo.data, addr: commandInfo.addr });
        },

        async setMultiGroup(context, info) {
            var cu = info.cu;
            var groupsData = info.data;
            console.log("preparo setMultiGroup", cu, groupsData);
            var pages = [];
            for (var l in groupsData) {
                var lamp = groupsData[l];
                var page = Math.floor(lamp.index / 32);
                var realIndex = lamp.index - page * 32;
                console.log("lamp " + lamp.index + "(" + lamp.id + ") -> page " + page + " index " + realIndex, lamp);
                var pageData = pages[page];
                if (pageData == null) {
                    pageData = [];
                    for (var i = 0; i < 32; i++) {
                        pageData.push(0);
                        pageData.push(0xffff);
                    }
                    pages[page] = pageData;
                }
                if (lamp.groups != null && lamp.groups.length > 0) {
                    for (var i = 0; i < lamp.groups.length; i++) {
                        var group = lamp.groups[i];
                        var vg = 1 << (group - 1)
                        pageData[realIndex * 2] += vg;
                        pageData[realIndex * 2 + 1] ^= vg;
                    }
                }

            }
            console.log("pages:", pages);
            var error_batch = false;
            if (pages.length > 1) {
                //Invio comando di apertura batch se comando multi su più pagine param=01 (apertura store batch)
                var temp_command = cu_command;
                var cu_command = {};
                cu_command.command = "setBatch";
                console.log("Apro batch comandi", cu_command);
                var resp_batch = await context.dispatch('sendLogicaCommand', { cu_command, cu_type: cu.cu_type, cu_id: cu.cu_id, param: "01", initialRetry: 3 });
                cu_command = temp_command;

                if (resp_batch.error != null && resp_batch.error != "") {
                    console.log("comando batch fallito!");
                    error_batch = true;
                }
            }

            if (error_batch == false) {
                for (var p in pages) {


                    var pdata = pages[p];

                    //converto l'array in stringa esadecimale
                    var dataStr = "0" + p;
                    for (var i = 0; i < 64; i++) {
                        var s = pdata[i].toString(16).padStart(4, '0').toUpperCase();
                        dataStr = dataStr + s;
                    }
                    console.log("data " + p + " -> " + dataStr);
                    //Invio il comando alla centrale passando dataStr che è pagina + bytes set/clear * 32 lampade
                    var resp = await context.dispatch('sendLogicaCommand', { cu_command: { command: 'setMultiGroup', data: dataStr }, cu_type: cu.cu_type, cu_id: cu.cu_id });
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "") {
                        console.log("comando fallito!");
                        break;
                    }

                    if (p == pages.length - 1 && pages.length > 1) {
                        //Invio comando di esecuzione batch (chiusura batch comandi + esecuzione) param=03 (esegui batch)
                        var cu_command = {};
                        cu_command.command = "setBatch";
                        console.log("Chiudo batch comandi", cu_command);
                        var resp_batch = await context.dispatch('sendLogicaCommand', { cu_command, cu_type: cu.cu_type, cu_id: cu.cu_id, param: "03", initialRetry: 3 });
                        if (resp_batch.error != null && resp_batch.error != "")
                            console.log("comando batch fallito!");
                    }
                }
            }

        },
        asyncDbSaveLampDescription(context, dati) {

            console.log("salvo lamp desc async", dati);

            return new Promise((resolve, reject) => {
                var resp = {
                    pending: true,
                    command: "asyncDbSaveLampDescription",
                    response: null,
                    error: null,
                    responseCallback: resolve
                };

                context.state.error = null;
                context.state.commandsPending += 1;
                context.state.loading = true;
                context.state.commandResponse = resp;
                Vue.prototype.$socket.sendObj({ action: 'saveLampDescription', data: { lampDescInfo: dati } });
            });
        },

        aggiornaNoteLogbook(context, dati) {

            console.log("aggiorno note logBook", dati);

            return new Promise((resolve, reject) => {
                var resp = {
                    pending: true,
                    command: "aggiornaNoteLogbook",
                    response: null,
                    error: null,
                    responseCallback: resolve
                };

                context.state.error = null;
                context.state.commandsPending += 1;
                context.state.loading = true;
                context.state.commandResponse = resp;
                Vue.prototype.$socket.sendObj({ action: "aggiornaNoteLogbook", data: dati });
            });


        },

        aggiornaClienteImpianto(context, dati) {

            console.log("aggiorno cliente impianto", dati);

            return new Promise((resolve, reject) => {
                var resp = {
                    pending: true,
                    command: "aggiornaClienteImpianto",
                    response: null,
                    error: null,
                    responseCallback: resolve
                };

                context.state.error = null;
                context.state.commandsPending += 1;
                context.state.loading = true;
                context.state.commandResponse = resp;
                Vue.prototype.$socket.sendObj({ action: "aggiornaClienteImpianto", data: dati });
            });


        },
        updatedPlantClient(context, msg) {
            console.log("ricevuto updatedPlantClient", msg)
                //context.state.loading = false;

            /*if (msg.data.error != null) {
                if (msg.data.error == 'MAPS_LIMIT_EXCEEDED') {
                    console.log("elimino ultima mappa");
                    var plant = context.state.currentPlant;
                    plant[msg.data.mapType].pop();
                    context.state.error = 'MAPS_LIMIT_EXCEEDED';
                }
            }*/

            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0);

            if (context.state.commandResponse != null && context.state.commandResponse.command == 'aggiornaClienteImpianto') {
                var resp = context.state.commandResponse;
                resp.pending = false;
                resp.response = msg.data;
                resp.error = msg.data.error;
                if (resp.responseCallback != null) {
                    console.log("completo promise!");
                    resp.responseCallback(resp);
                }
            }

            /*if (msg.data != false) {
                console.log("impianto salvato")
                //La navbar viene portata sul nuovo impianto creato
                context.state.userLastPlants.unshift(msg.data);
            } else {
                console.log("errore in salvataggio impianto in db")
            } */
        },

        updatedNoteLogbook(context, msg) {
            console.log("ricevuto updatedNoteLogbook", msg)
                //context.state.loading = false;
            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0);

            if (context.state.commandResponse != null && context.state.commandResponse.command == 'aggiornaNoteLogbook') {
                var resp = context.state.commandResponse;
                resp.pending = false;
                resp.response = msg.data;
                resp.error = msg.data.error;
                if (resp.responseCallback != null) {
                    console.log("completo promise!");
                    resp.responseCallback(resp);
                }
            }
        },

        deletedFile(context, msg) {
            console.log("ricevuto deletedFile", msg)
                //context.state.loading = false;
            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0);

            if (context.state.commandResponse != null && context.state.commandResponse.command == 'deleteFile') {
                var resp = context.state.commandResponse;
                resp.pending = false;
                resp.response = msg.data;
                resp.error = msg.data.error;
                if (resp.responseCallback != null) {
                    console.log("completo promise!");
                    resp.responseCallback(resp);
                }
            }
        },

        deleteFile(context, dati) {
            return new Promise((resolve, reject) => {
                var resp = {
                    pending: true,
                    command: "deleteFile",
                    response: null,
                    error: null,
                    responseCallback: resolve
                };

                context.state.error = null;
                context.state.commandsPending += 1;
                context.state.loading = true;
                context.state.commandResponse = resp;
                Vue.prototype.$socket.sendObj({ action: "deleteFile", data: dati });

            });
        },

        deleteFileNew(context, dati) {
            return new Promise((resolve, reject) => {
                var resp = {
                    pending: true,
                    command: "deleteFile",
                    response: null,
                    error: null,
                    responseCallback: resolve
                };

                context.state.error = null;
                context.state.commandsPending += 1;
                context.state.loading = true;
                context.state.commandResponse = resp;
                Vue.prototype.$socket.sendObj({ action: "deleteFileNew", data: dati });

            });
        },

        sendLogicaCommand(context, commandInfo) {
            var resp = null;
            console.log("Invio comando logica, initialRetry: " + commandInfo.initialRetry, commandInfo);

            return new Promise((resolve, reject) => {

                context.state.loading = true;
                context.state.error = null;

                var isRetryCall = false;

                if (commandInfo.retry == null) {
                    var timeout_setting;
                    if (commandInfo.cu_type != "logicafm" && commandInfo.cu_type != "sicuro") {
                        context.state.commandResponse.retry = 3;
                        timeout_setting = 5;
                    } else {
                        context.state.commandResponse.retry = 0;
                        timeout_setting = 12;
                        commandInfo.initialRetry = 0;
                    }
                    var cmd = commandInfo.cu_command.command || commandInfo.cu_command;

                    console.log("è il primo comando cmd=" + cmd + ", initialRetry=" + commandInfo.initialRetry + ", timeout_setting=" + timeout_setting);

                    commandInfo.responseCallback = resolve;

                    resp = {
                        pending: true,
                        command: cmd,
                        response: null,
                        error: null,
                        cu: null,
                        timeout: timeout_setting,
                        retry: (commandInfo.initialRetry != null && commandInfo.initialRetry != 'undefined') ? commandInfo.initialRetry : 10,
                        timeoutId: null,
                        commandInfo: commandInfo,
                    };
                } else {
                    resp = {
                        pending: true,
                        command: commandInfo.cu_command,
                        response: null,
                        error: null,
                        cu: null,
                        timeout: 5,
                        retry: commandInfo.retry,
                        timeoutId: null,
                        commandInfo: commandInfo,
                    };
                    console.log("resp on error", resp);
                    isRetryCall = true;
                }
                context.state.commandResponses[commandInfo.cu_id] = resp;


                let cent = context.state.plantUnits.find(function(c) {
                    if (c.cu_id == commandInfo.cu_id) return c;
                    return null;
                });
                if (cent != null) {
                    cent["working"] = true
                    console.log("aggiornato working su " + cent.cu_id, cent);
                    setTimeout(function() {
                        if (cent != null && cent != undefined) cent["working"] = false
                    }, 35000);
                }
                context.state.commandsPending = Math.max(1, context.state.commandsPending + 1);

                if (resp.timeout > 0) {
                    resp.timeoutId = setTimeout(function() {
                        //Eseguo la funzione di controllo del timeout del comando
                        context.commit('checkCommandTimeout', commandInfo.cu_id);
                        var retryAgain = resp.retry;
                        context.state.commandsPending = context.state.commandsPending - 1;
                        if (retryAgain > 0) {
                            console.log("ripeto il comando sendLogicaCommand")
                            resp.retry = resp.retry - 1;
                            context.state.commandsPending -= 1;
                            commandInfo.retry = resp.retry + 0;
                            context.dispatch('sendLogicaCommand', commandInfo);
                        } else {
                            console.log("comando fallito dopo tutti i retry");
                            cent["working"] = false;
                            //context.state.loading = false;
                            context.state.commandResponse = resp;
                            context.state.loading = (context.state.commandsPending > 0); // false;


                            if (commandInfo.responseCallback != null) {
                                commandInfo.responseCallback(resp);
                            }
                        }
                    }, resp.timeout * 1000);
                }

                if (commandInfo.cu_command.command == "setMultiParam")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { cu_type: commandInfo.cu_type, topic: commandInfo.cu_type + "_" + commandInfo.cu_id, page: commandInfo.page, indexes: commandInfo.indexes, autonomy: commandInfo.cu_command.autonomy, parity: commandInfo.cu_command.parity, infinity: commandInfo.cu_command.infinity, mode: commandInfo.cu_command.mode, opticom: commandInfo.cu_command.opticom, durataTest: commandInfo.cu_command.durataTest, uvOxyOnOff: commandInfo.cu_command.uvOxyOnOff, uvOxyTimer: commandInfo.cu_command.uvOxyTimer, uvOxyFanSpeed: commandInfo.cu_command.uvOxyFanSpeed } });
                else if (commandInfo.cu_command.command == "setBatch")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, param: commandInfo.param } });
                else if (commandInfo.cu_command.command == "setLgSerialId")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, page: commandInfo.page, lampId: commandInfo.lamp_id } });
                else if (commandInfo.cu_command.command == "substituteLogicaFM")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, old: commandInfo.old, new: commandInfo.new } });
                else if (commandInfo.cu_command.command == "createNetwork")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, plant_code: commandInfo.plant_code } });
                else if (commandInfo.cu_command.command == "deleteLgSerialId")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, lampId: commandInfo.lamp_id } });
                else if (commandInfo.cu_command.command == "setParam")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, page: commandInfo.page, addr: commandInfo.addr, autonomy: commandInfo.cu_command.autonomy, parity: commandInfo.cu_command.parity, infinity: commandInfo.cu_command.infinity, mode: commandInfo.cu_command.mode } });
                else if (commandInfo.cu_command.command == "setGroup")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, indexes: commandInfo.indexes, page: commandInfo.page, group: commandInfo.cu_command.groupNumber } });
                else if (commandInfo.cu_command.command == "removeGroup")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, indexes: commandInfo.indexes, page: commandInfo.page, group: commandInfo.cu_command.groupNumber } });
                else if (commandInfo.cu_command.command == "setMultiGroup")
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command.command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, payload: commandInfo.cu_command.data } });
                else if (commandInfo.cu_command == 'setCuName')
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, cuName: commandInfo.cuName } });
                else if (commandInfo.cu_command == 'setLampName')
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, page: commandInfo.page, lampName: commandInfo.lampName, lampIndex: commandInfo.lampIndex, lampId: commandInfo.lampId } });
                else if (cmd == 'setDateTimeFunzionale') {
                    console.log("invio cmd setDateTimeFunzionale");
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setFunzionale: commandInfo.cu_command.set_functional } });
                } else if (cmd == 'setDateTimeAutonomia') {
                    console.log("invio cmd setDateTimeAutonomia");
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, setAutonomia: commandInfo.cu_command.set_autonomy } });
                } else if (cmd == 'setPeriodAutonomia') {
                    console.log("invio cmd setPeriodicitàAutonomia");
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, periodAutonomia: commandInfo.cu_command.period_autonomy, differito: commandInfo.cu_command.differito } });
                } else if (cmd == 'setPeriodFunzionale') {
                    console.log("invio cmd setPeriodicitàFunzionale");
                    Vue.prototype.$socket.sendObj({ action: cmd, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, periodFunzionale: commandInfo.cu_command.period_functional } });
                } else
                    Vue.prototype.$socket.sendObj({ action: commandInfo.cu_command, data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id, addr: commandInfo.addr } });

                if (isRetryCall) resolve();
            });
        },

        sendLogicaConfigCommand(context, commandInfo) {
            console.log("Invio comando Logica config, loading= " + context.state.loading + ", pending:" + context.state.commandsPending, commandInfo);
            var resp = context.state.commandResponses[commandInfo.centId];

            if (resp == null) {
                var resp = {
                    pending: true,
                    command: "",
                    response: null,
                    error: null,
                    cu: null,
                    timeout: 5,
                    retry: 1,
                    timeoutId: null
                };
                context.state.commandResponses[commandInfo.centId] = resp;
            }

            if (!resp.pending) {
                resp.retry = 1;
                resp.timeout = 5;
            }


            if (!context.state.commandsPending) {
                context.state.commandResponse.retry = 1;
                context.state.commandResponse.timeout = 5;
            }
            context.state.loading = true;
            context.state.error = null;
            context.state.commandsPending += 1;


            if (resp.timeout > 0) {
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    context.commit('checkCommandTimeout', commandInfo.centId);
                    var retryAgain = context.state.commandResponse.retry;
                    if (retryAgain > 0) {
                        console.log("ripeto il comando sendCablecomConfigCommand")
                        context.state.commandResponse.retry = context.state.commandResponse.retry - 1;
                        context.state.commandsPending -= 1;
                        context.dispatch('sendCablecomConfigCommand', commandInfo);
                    }
                }, resp.timeout * 1000);
            }

            Vue.prototype.$socket.sendObj({ action: "configLogica", data: { topic: commandInfo.centType + "_" + commandInfo.centId, modalita_config_logica: commandInfo.modalita_config_logica } });
        },

        sendCablecomConfigCommand(context, commandInfo) {
            var resp = context.state.commandResponses[commandInfo.centId];
            console.log("Invio comando Cablecom config, loading= " + context.state.loading + ", pending:" + context.state.commandsPending, commandInfo, resp);

            if (resp == null) {
                resp = {
                    pending: true,
                    command: "config",
                    response: null,
                    error: null,
                    cu: commandInfo.centId,
                    timeout: 5,
                    retry: 1,
                    timeoutId: null
                };
                context.state.commandResponses[commandInfo.centId] = resp;
            }

            if (!resp.pending) {
                resp.retry = 1;
                resp.timeout = 5;
            }

            if (!context.state.commandsPending) {
                context.state.commandResponse.retry = 1;
                context.state.commandResponse.timeout = 5;
            }
            context.state.loading = true;
            context.state.error = null;
            context.state.commandsPending += 1;

            if (resp.timeout > 0) {
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    context.commit('checkCommandTimeout', commandInfo.centId);
                    var retryAgain = context.state.commandResponse.retry;
                    if (retryAgain > 0) {
                        console.log("ripeto il comando sendCablecomConfigCommand")
                        context.state.commandResponse.retry = context.state.commandResponse.retry - 1;
                        context.state.commandsPending -= 1;
                        context.dispatch('sendCablecomConfigCommand', commandInfo);
                    }
                }, resp.timeout * 1000);
            }

            Vue.prototype.$socket.sendObj({ action: "config", data: { topic: commandInfo.centType + "_" + commandInfo.centId, num_lamp: commandInfo.num_lamp, ore_autonomia: commandInfo.ore_autonomia } });
        },
        sendCablecomConfigStatusCommand(context, commandInfo) {


            var resp = context.state.commandResponses[commandInfo.cu_id];

            console.log("Invio comando config status, commandsPending=", context.state.commandsPending, commandInfo, resp);

            if (resp == null) {
                resp = {
                    pending: true,
                    command: "GET DATI IMPIANTO",
                    response: null,
                    error: null,
                    cu: commandInfo.cu_id,
                    timeout: 5,
                    retry: 0,
                    timeoutId: null
                };
                context.state.commandResponses[commandInfo.cu_id] = resp;
            }

            if (!resp.pending) {
                resp.retry = 0;
                resp.timeout = 5;
            }

            /*if (!context.state.commandsPending) {
                context.state.commandResponse.retry = 3;
                context.state.commandResponse.timeout = 5;
            }*/
            context.state.error = null;
            context.state.commandsPending += 1;

            if (resp.timeout > 0) {
                console.log("resp timeout, retry = " + resp.retry + " --> commandInfo:", commandInfo);
                resp.timeoutId = setTimeout(function() {
                    //Eseguo la funzione di controllo del timeout del comando
                    context.commit('checkCommandTimeout', commandInfo.cu_id);
                    var retryAgain = resp.retry;
                    if (retryAgain > 0) {

                        resp.retry = resp.retry - 1;
                        resp.pending = true;
                        context.state.commandsPending -= 1;
                        context.state.commandResponses[commandInfo.cu_id] = resp;
                        console.log("ripeto il comando sendCablecomConfigStatusCommand " + (resp.retry + 0), resp);
                        setTimeout(function() {
                            context.dispatch('sendCablecomConfigStatusCommand', commandInfo);
                        }, 6000);
                    }
                }, resp.timeout * 1000);
            }


            Vue.prototype.$socket.sendObj({ action: "getStatoConfig", data: { topic: commandInfo.cu_type + "_" + commandInfo.cu_id } });
        },
        aggiornaMappe(context, datiMappe) {
            console.log("aggiorno mappe", datiMappe);
            context.state.error = null;
            context.state.commandsPending += 1;
            context.state.loading = true;
            Vue.prototype.$socket.sendObj({ action: "aggiornaMappe", data: datiMappe });
        },
        aggiornaMappePost(context, data) {

            console.log("aggiorno mappe via API REST POST", data);

            return new Promise((resolve, reject) => {
                context.state.loading = true;
                Vue.prototype.$axios.post('', {
                        action: 'aggiornaMappePost',
                        socketId: context.state.socketId,
                        datiMappe: data
                    })
                    .then(function(response) {
                        console.log("aggiornamento mappe eseguito", response);
                        context.state.commandsPending = context.state.commandsPending - 1;
                        context.state.loading = (context.state.commandsPending > 0);
                        resolve(response);
                    })
                    .catch(function(error) {
                        console.log("errore aggiornamento mappe", error);
                        resolve(error);
                    });
            });

        },
        //-------------------------------------------------------------------------------------
        // Comando per aggiornare una singola mappa (planimetria/ambiente)
        //-------------------------------------------------------------------------------------
        aggiornaSingolaMappaPost(context, data) {

            console.log("aggiorno singola mappa via API REST POST", data);

            return new Promise((resolve, reject) => {
                context.state.loading = true;
                Vue.prototype.$axios.post('', {
                        action: 'aggiornaSingolaMappaPost',
                        socketId: context.state.socketId,
                        datiMappa: data
                    })
                    .then(function(response) {
                        console.log("aggiornamento mappa eseguito", response);
                        context.state.commandsPending = context.state.commandsPending - 1;
                        context.state.loading = (context.state.commandsPending > 0);
                        resolve(response);
                    })
                    .catch(function(error) {
                        console.log("errore aggiornamento mappe", error);
                        resolve(error);
                    });
            });

        },
        //-------------------------------------------------------------------------------------
        // Ricezione risposta cmd di aggiornamento mappe
        //-------------------------------------------------------------------------------------
        mappeUpdated(context, msg) {
            console.log("ricevuto mappeUpdated", msg)
                //context.state.loading = false;

            if (msg.data.error != null) {
                if (msg.data.error == 'MAPS_LIMIT_EXCEEDED') {
                    console.log("elimino ultima mappa");
                    var plant = context.state.currentPlant;
                    plant[msg.data.mapType].pop();
                    context.state.error = 'MAPS_LIMIT_EXCEEDED';
                }
            }

            context.state.commandsPending = context.state.commandsPending - 1;
            context.state.loading = (context.state.commandsPending > 0);
            /*if (msg.data != false) {
                console.log("impianto salvato")
                //La navbar viene portata sul nuovo impianto creato
                context.state.userLastPlants.unshift(msg.data);
            } else {
                console.log("errore in salvataggio impianto in db")
            } */
        },
        invitaDelegato(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "invitaDelegato";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'invitaDelegato', data: data });
        },
        invitatoDelegato(context, data) {
            console.log("ricevuto invitatoDelegato", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'invitaDelegato',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        rimuoviDelegato(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "rimuoviDelegato";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'rimuoviDelegato', data: data });
        },
        rimossoDelegato(context, data) {
            Vue.set(context.state.currentPlant, 'plant_users', data.data);
            context.state.commandResponse.pending = false;
            var resp = {
                pending: false,
                command: 'rimuoviDelegato',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        invitaCollaboratore(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "invitaCollab";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'invitaCollab', data: data });
        },
        invitatoCollab(context, data) {
            console.log("ricevuto invitatoCollab", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'invitaCollab',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        rimuoviCollaboratore(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "rimuoviCollaboratore";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'rimuoviCollab', data: data });
        },
        rimossoCollab(context, data) {
            Vue.set(context.state.currentPlant, 'plant_users', data.data);
            context.state.commandResponse.pending = false;
            var resp = {
                pending: false,
                command: 'rimuoviCollaboratore',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        getListaInviti(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "listaInviti";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'listaInviti', data: data });
        },
        listaInviti(context, data) {
            console.log("ricevuto listaInviti", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'listaInviti',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },

        getPlantUsers(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "getPlantUsers";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            console.log("invio getPlantUsers", data);
            Vue.prototype.$socket.sendObj({ action: 'getPlantUsers', data: data });
        },
        plantUsers(context, data) {
            console.log("ricevuto plantUsers", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'getPlantUsers',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },

        eliminaInvito(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "eliminaInvito";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'eliminaInvito', data: data });
        },
        invitoEliminato(context, data) {
            console.log("ricevuto invitoEliminato", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'eliminaInvito',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },

        invitaCliente(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "invitaCliente";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'invitaCliente', data: data });
        },
        invitatoCliente(context, data) {
            console.log("ricevuto invitatoCliente", data);
            context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'invitaCliente',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        abilitaPro(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "upgradePlant";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            //context.state.commandsPending += 1;
            Vue.prototype.$socket.sendObj({ action: 'abilitaPro', data: data });
        },
        upgradePlant(context, data) {
            console.log("ricevuto upgradePlant", data);
            //context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'upgradePlant',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },
        abilitaNotificheErrori(context, data) {
            context.state.commandResponse.pending = true;
            context.state.commandResponse.command = "updateNotificheErrori";
            context.state.commandResponse.response = null;
            context.state.commandResponse.error = null;
            context.state.error = null;
            Vue.prototype.$socket.sendObj({ action: 'abilitaNotificheErrori', data: data });
        },

        updateNotificheErrori(context, data) {
            console.log("ricevuto updateNotificheErrori", data);
            //context.state.commandResponse.pending = false;

            var resp = {
                pending: false,
                command: 'updateNotificheErrori',
                response: data
            }
            Vue.set(context.state, "commandResponse", resp);
        },

        loadPlantZones(context, data) {
            console.log("invio richiesta dati delle zone " + data);
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'getZonesPost',
                    plantId: data
                })
                .then(function (response) {
                    console.log("arrivato callback post ble zones", response);
                    context.loading = false;
                    context.commit('setPlantZones', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        loadPlantMonitoringZones(context, data) {
            console.log("Store, richiesta zone di monitoraggio: " + data);
            context.state.loading = true;
            Vue.prototype.$axios.post('', {
                    action: 'getMonitoringZonesPost',
                    plantId: data
                })
                .then(function(response) {
                    console.log("store, set delle zone ricevute: ", response.data);
                    context.commit('setMonitoringZones', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore monitoring zones post", error);
                });
        },

        loadProductInfo(context, data) {
            console.log("invio richiesta Info su prodotto " + data);
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getProductInfo',
                    productId: data
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateSingleProductInfo', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        loadFamilyInfo(context, data) {
            console.log("invio richiesta Info su famigliao " + data);
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getFamilyInfo',
                    familyId: data
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateFamilyInfo', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },

        loadAllCuProductInfo(context) {
            console.log("invio richiesta Info sui tipi di centrali");
            context.state.loading = true;
            //axios.baseurl configurata nel file main.js attraverso la variabile process.env.VUE_APP_API_REST_URL
            Vue.prototype.$axios.post('', {
                    action: 'getAllCuInfo',
                })
                .then(function(response) {
                    console.log("post eseguita", response);
                    context.commit('updateAllCuProductInfo', response.data);
                    context.state.loading = false;
                })
                .catch(function(error) {
                    console.log("errore post", error);
                });
        },
    }
})
